<template lang="html">
  <section class="price_configurator">
    <!--market and model-->
    <b-tooltip target="tooltip-target-1" triggers="hover">
    </b-tooltip>
    <b-card header="Market and Model" header-bg-variant="primary" header-text-variant="light" id="market_model">
      <b-card-text>
        <b-row>
          <b-col class="col-lg-1 pt-2">Market:</b-col>

          <b-select class="col-lg-5" v-model="selectedCountry" id="selectedCountry"
            v-if="!isFromSol && !isFromCampaign">
            <option :value="country" v-if="getCurUser" v-for="(country, index) in getCurUser.countries">{{
              country.description }}</option>
          </b-select>
          <b-select class="col-lg-5" v-model="selectedCountry" id="selectedCountry" v-else disabled>
            <option :value="country" v-if="getCurUser" v-for="(country, index) in getCurUser.countries">{{
              country.description }}</option>
          </b-select>
          <b-col class="col-lg-1 pt-2">Model:</b-col>

          <b-select class="col-lg-5" v-model="selectedModel" id="selectedModel" v-if="!isFromSol && !isFromCampaign">
            <template v-if="selectedCountry != null && selectedCountry.modelGroupItemList"
              v-for="models in ((selectedCountry && selectedCountry.modelGroupItemList) ? selectedCountry.modelGroupItemList : [])">
              <optgroup :label="models.label">
                <option v-for="(model, index) in models.items" :key="index" :value="model">{{ model.label }}</option>
              </optgroup>
            </template>
          </b-select>
          <b-select class="col-lg-5" v-model="selectedModel" id="selectedModel" v-else disabled>
            <template v-if="selectedCountry != null && selectedCountry.modelGroupItemList"
              v-for="models in ((selectedCountry && selectedCountry.modelGroupItemList) ? selectedCountry.modelGroupItemList : [])">
              <optgroup :label="models.label">
                <option v-for="(model, index) in models.items" :key="index" :value="model">{{ model.label }}</option>
              </optgroup>
            </template>
          </b-select>
        </b-row>
        <!-- Inizio Modal import -->
        <b-modal id="modal-import" title="Upload File" size="lg" header-bg-variant="primary" header-text-variant="light"
          centered>

          <div class='modal-body'>
            <!-- Form -->
            <form method='post' action='' enctype='multipart/form-data'>
              <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input' name='filename' @change="changeFileName()">
                <label class='custom-file-label' for='file-input'>{{ fileName }}</label>
              </div>
              <br>
            </form>
            <!-- Preview-->
            <!-- <div id='preview'></div> -->
            <h2 v-if="imported">Import executed</h2>
            <template v-if='uploadImportPricelistResultView'>
              <span style="color:red;" v-for="errorMsg in uploadImportPricelistResultView.uploadErrorMsgList">
                {{ errorMsg }}
              </span><br />
            </template>
            <b-table id="uploadBasePricePreview" striped border hover responsive sticky-header="500px" small
              :items="uploadImportPricelistResultView ? uploadImportPricelistResultView.basePriceList : []"
              :fields="uploadPreviewFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" primary-key="_id"
              no-local-sorting no-provider-paging sort-icon-left class="mt-3">
              <!-- Custom row above header -->
              <template v-slot:thead-top="data" lang="html">
                <b-tr>
                  <b-th variant="secondary" :colspan="uploadPreviewFields.length">BASEPRICE</b-th>
                </b-tr>
              </template>
              <!--  rows  -->
              <template v-slot:cell(isChecked)="data" lang="html">
                <input v-if="data.item.status == 0" type="checkbox" v-model="data.item.isChecked"
                  @change="editUploadedItem(data.item)" checked="data.item.isChecked" />
                <i v-if="data.item.status != 0" class="mdi mdi-window-close" v-model="data.item.isChecked = false"
                  style="display: block; color:red;"><!-- --></i>
              </template>
              <template v-slot:cell(officialPrice)="data" lang="html">
                <input v-if="data.item.status == 0" type="text" v-model="data.item.officialPrice"
                  @change="editUploadedItem(data.item)" />
                <span v-if="data.item.status != 0" v-model="data.item.officialPrice">{{ data.item.officialPrice }} -
                  {{ data.item.statusDescription }}</span>
              </template>
              <template v-slot:cell(status)="data" lang="html">
                <i v-if="data.item.status == 0 && imported" class="mdi mdi-check"
                  style="display: block; color:green;"><!-- --></i>
                <i v-if="data.item.status == 1" class="mdi mdi-exclamation"
                  style="display: block; color:yellow;"><!-- --></i>
                <i v-if="data.item.status == 2" class="mdi mdi-window-close"
                  style="display: block; color:red;"><!-- --></i>
              </template>
            </b-table>
            <b-table id="uploadEquipmentPreview" striped border hover responsive sticky-header="500px" small
              :items="uploadImportPricelistResultView ? uploadImportPricelistResultView.uploadedList : []"
              :fields="uploadPreviewFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" primary-key="_id"
              no-local-sorting no-provider-paging sort-icon-left class="mt-3">
              <!-- Custom row above header -->
              <template v-slot:thead-top="data" lang="html">
                <b-tr>
                  <b-th variant="secondary" :colspan="uploadPreviewFields.length">EQUIPMENTS (OPTIONALS / CUSTOMER
                    PROGRAMS /
                    ACCESSORIES)</b-th>
                </b-tr>
              </template>
              <!--  rows  -->
              <template v-slot:cell(isChecked)="data" lang="html">
                <input v-if="data.item.status == 0" type="checkbox" v-model="data.item.isChecked"
                  @change="editUploadedItem(data.item)" checked="data.item.isChecked" />
                <i v-if="data.item.status != 0" class="mdi mdi-window-close" v-model="data.item.isChecked = false"
                  style="display: block; color:red;"><!-- --></i>
              </template>
              <template v-slot:cell(officialPrice)="data" lang="html">
                <input v-if="data.item.status == 0" type="text" v-model="data.item.officialPrice"
                  @change="editUploadedItem(data.item)" />
                <span v-if="data.item.status != 0" v-model="data.item.officialPrice">{{ data.item.officialPrice }} -
                  {{ data.item.statusDescription }}</span>
              </template>
              <template v-slot:cell(status)="data" lang="html">
                <i v-if="data.item.status == 0 && imported" class="mdi mdi-check"
                  style="display: block; color:green;"><!-- --></i>
                <i v-if="data.item.status == 1" class="mdi mdi-exclamation"
                  style="display: block; color:yellow;"><!-- --></i>
                <i v-if="data.item.status == 2" class="mdi mdi-window-close"
                  style="display: block; color:red;"><!-- --></i>
              </template>
            </b-table>
          </div>
          <template v-slot:modal-footer="{ cancel, ok }" lang="html">
            <fragment>
              <!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
              <b-button variant="secondary" @click="cancel()">
                Annulla
              </b-button>
              <b-button variant="primary" @click="uploadFile()">
                Upload
              </b-button>
              <b-button v-if="uploadImportPricelistResultView" variant="primary" @click="importPriceList()">
                Import
              </b-button>
            </fragment>
          </template>
        </b-modal>
        <!-- Fine Modal import -->
        <b-row class="mt-3">
          <b-col class="col-lg-4"></b-col>
          <b-col class="col-lg-8">
            <span class="float-right">
              <b-button variant="primary mr-1"
                v-if="comeFromSolCampaign || startFromSolCampaign || isFromSol || startFromSolModel" @click="back()"><i
                  class="mdi mdi-arrow-left"></i>Back</b-button>
              <b-button variant="primary mr-1" @click="reloadBaseInfo()"><i
                  class="mdi mdi-refresh"></i>Refresh</b-button>
              <b-button v-if="selectedCountry && selectedCountry.enableBaseOpt" variant="primary mr-1"
                @click="exportPriceList()"><i class="mdi mdi-file-export"></i>Export</b-button>
              <b-button v-if="selectedCountry && selectedCountry.enableBaseOpt" variant="primary mr-1"
                @click="initializeUpload()"><i class="mdi mdi-file-import"></i>Import</b-button>
              <b-button v-if="selectedCountry && selectedCountry.enableBaseOpt"
                v-b-modal.modal-price-configurator-exception variant="primary mr-1">
                Alternative Pricelists</b-button>
              <b-button variant="primary"
                :class="!(selectedCountry.enableBaseOpt || selectedCountry.enableAccessories) ? 'disabled' : ''"
                v-if="selectedCountry != null && selectedCountry && (selectedCountry.enableBaseOpt || selectedCountry.enableAccessories)"
                @click="openPdf()"><i class="mdi mdi-download"></i>Tutorial for Area Manager</b-button>
            </span>
          </b-col>
        </b-row>
        <!-- Inizio Modal Price Configurator Exception -->
        <b-modal id="modal-price-configurator-exception" title="Price Configurator Exception" size="lg"
          header-bg-variant="primary" header-text-variant="light" class="modal-price-configurator-exception"
          :scrollable="true" ref="PriceConfiguratoException">
          <PriceConfiguratorException :selectedCountry="selectedCountry" :selectedModel="selectedModel"
            :optionalList="cloneObject(optionalList)" :basePriceInfo="cloneObject(basePriceInfo)"
            :fuoriserieList="cloneObject(fuoriserieList)" :customerPrgList="cloneObject(customerPrgList)"
            :accessoriesList="cloneObject(accessoriesList)" :isPriceFromAS400="isPriceFromAS400"
            :activePricemask="activePricemask" :activeCurrency="activeCurrency" :sortBy="sortBy" :sortDesc="sortDesc"
            :equipmentsTableKey="equipmentsTableKey" :labels="labels" :specificVisibleFields="specificVisibleFields"
            :optVisibleButtons="optVisibleButtons" :getCurUser="getCurUser" :isFromSol="isFromSol"
            :isFromCampaign="isFromCampaign" :accVisibleButtons="accVisibleButtons" :authHeader="authHeader"
            :backupData="backupData" @setPriceTo="setPriceTo" @rollbackInfo="rollbackInfo" @showAlert="showAlert"
            @mainListRollback="mainListRollback" @importAllPrices="importAllPrices" @getBorderStyle="getBorderStyle"
            @rollbackMe="rollbackMe" @openModalInfo="openModalInfo" @priceMeTo="priceMeTo"
            @getModelBasePriceInfo="getModelBasePriceInfo" @setSpinnerStatus="setSpinnerStatus" @closeModal="closeModal"
            @updateBackupData="updateBackupData" @restoreBackup="restoreBackup"></PriceConfiguratorException>
        </b-modal>
        <!-- Fine Modal Price Configurator Exception -->
      </b-card-text>
    </b-card>

    <!--Settings-->
    <b-card v-if="basePriceInfo" header="Settings" header-bg-variant="primary" header-text-variant="light"
      id="settings_section">
      <b-card-text>
        <!-- Shopping tool visibility (placeholder) -->
        <b-row class="mb-4">
          <b-col class="col-lg-12">
            <h4 class="mb-3">Shopping tool visibility</h4>
            <!--Car Configurator / MXE / SNI ecc... -->
            <b-row>
              <b-col class="col-lg-2 pt-2">Visible:</b-col>
              <b-col class="col-lg-1">
                <span :title="getTooltip('TOOLTIP_VISIBLE')">
                  <b-form-checkbox class="col-lg-1 mr-1" v-model="basePriceInfo.pricelistActive"></b-form-checkbox>
                </span>
              </b-col>

              <b-col class="col-lg-2 pt-2">Car Configurator:</b-col>
              <b-col class="col-lg-1">
                <span :title="getTooltip('TOOLTIP_CAR_CONFIGURATOR')">
                  <b-form-checkbox class="col-lg-1 mr-1" v-model="priceSettings.showCC" :disabled="!basePriceInfo.pricelistActive"></b-form-checkbox>
                </span>
              </b-col>

              <b-col class="col-lg-2 pt-2">MXE:</b-col>
              <b-col class="col-lg-1">
                <span :title="getTooltip('TOOLTIP_MXE')">
                  <b-form-checkbox class="col-lg-1 mr-1" v-model="priceSettings.showMXE" :disabled="!basePriceInfo.pricelistActive"></b-form-checkbox>
                </span>
              </b-col>

              <b-col class="col-lg-2 pt-2">SNI:</b-col>
              <b-col class="col-lg-1">
                <span :title="getTooltip('TOOLTIP_SNI')">
                  <b-form-checkbox class="col-lg-1 mr-1" v-model="priceSettings.showSNI" :disabled="!basePriceInfo.pricelistActive"></b-form-checkbox>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!-- Price management -->
        <!-- La sezione Price Management è visibile solo se selectedCountry.automaticPrice === true -->
        <div v-if="selectedCountry && selectedCountry.automaticPrice === true">
          <b-row class="mb-2">
            <b-col class="col-lg-12">
              <h4 class="mb-3">Price management</h4>
            </b-col>
          </b-row>

          <b-row class="align-items-center mb-3">
            <b-col class="col-lg-2 pt-2">Automatic:</b-col>
            <b-col class="col-lg-2">
              <span :title="getTooltip('TOOLTIP_AUTOMATIC')">
                <b-form-checkbox v-model="priceSettings.automaticPrice"
                  :disabled="!selectedCountry.enableBaseOpt"></b-form-checkbox>
              </span>
            </b-col>

            <b-col class="col-lg-1 pt-2">VAT:</b-col>
            <b-col class="col-lg-2">
              <input :title="getTooltip('TOOLTIP_VAT')" id="VAT-field" type="number" min="0" max="100" step="0.01"
                class="form-control" v-model.number="automaticVatLocal" :disabled="!priceSettings.automaticPrice"/>
            </b-col>
            <b-col class="col-lg-1 pt-2">%</b-col>
          </b-row>
        </div>
        <b-row>
          <b-col class="col-lg-12">
            <span class="float-right">
              <b-button variant="primary" @click="savePriceSettings">
                Save
              </b-button>
            </span>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <!-- Modale di avviso per attivazione automatica senza prezzi -->
    <b-modal id="modal-auto-pricing-warning" title="Warning" size="md" header-bg-variant="danger"
      header-text-variant="light" ok-only ok-title="OK" centered>
      Automatic pricing cannot be activated because there are no prices in the pricelist
    </b-modal>

    <b-card header="Discount and On-Line Visibility" header-bg-variant="primary" header-text-variant="light"
      id="discount_and_visibility" v-if="!getCurUser.isDealer">
      <template v-if="solModel != null"> <!--  activeSolCampaign -->
        <!--se arrivi da sol tutto in sola lettura tranne il cambio di visibilità che segue il flag Hq-->
        <template>
          <b-card-text>
            <b-row>
              <div class="col-sm-2 pt-2">Visibility: </div>
              <template v-if="!canModify">
                <b-form-select class="col-sm-8 col-lg-2 mr-1" disabled="disabled" readonly="readonly"
                  v-model="solModel.visible" :options="options"></b-form-select>
              </template>
              <template v-else>
                <b-form-select class="col-sm-8 col-lg-2 mr-1" v-model="solModel.visible"
                  :options="options"></b-form-select>
              </template>
            </b-row>
          </b-card-text>
          <template v-if="activeSolCampaign">
            <b-card-text>
              <b-row>
                <div class="col-sm-2 pt-2">Model Discount Percentage: </div>
                <input disabled="disabled" readonly="readonly" type="number" min="0" max="100" class="col-lg-2 mr-1"
                  v-model="activeSolCampaign.discPerc" />
                <div class="col-sm-1 pt-2"> % </div>
                <div class="col-sm-1 pt-2 mx-auto"> or </div>
                <div class="col-sm-1 pt-2 mx-auto"> Absolute </div>
                <input disabled="disabled" readonly="readonly" type="number" class="col-lg-2 mr-1"
                  v-model="activeSolCampaign.discTot" />
                <div class="col-sm-1 pt-2"> {{ selectedCountry.currency }} </div>
              </b-row>
            </b-card-text>
            <b-card-text>
              <b-row>
                <div class="col-sm-2 pt-2">OPT Discount Percentage: </div>
                <input disabled="disabled" readonly="readonly" type="number" min="0" max="100" class="col-lg-2 mr-1"
                  v-model="activeSolCampaign.discOpt" />
                <div class="col-sm-1 pt-2"> % </div>
                <!-- Colonne bottoni-->
                <b-col class="col-lg-12">
                  <span class="float-right">
                    <b-button variant="primary mr-1" @click="rollbackSolData()"><i
                        class="mdi mdi-rotate-left"></i>Rollback</b-button>
                    <b-button v-if="!showEditButton(activeSolCampaign)" variant="primary mr-1" disabled>
                      Save
                    </b-button>
                    <b-button v-else variant="primary  mr-1" @click="toggleElementStatus(solModel, solModel.visible)">
                      Save
                    </b-button>
                    <b-button variant="primary mr-1" v-if="!comeFromSolCampaign && !startFromSolCampaign"
                      @click='goToCampaign()'><i class="mdi mdi-arrow-top-right"></i>Go To Campaign</b-button>
                    <b-button variant="primary mr-1" v-else disabled><i class="mdi mdi-arrow-top-right"></i>Go To
                      Campaign</b-button>

                  </span>
                </b-col>
              </b-row>
            </b-card-text>
          </template>
          <template v-else>
            <b-card-text>
              <b-row>
                <div class="col-sm-2 pt-2">Model Discount Percentage: </div>
                <input disabled="disabled" readonly="readonly" type="number" min="0" max="100" class="col-lg-2 mr-1" />
                <div class="col-sm-1 pt-2"> % </div>
                <div class="col-sm-1 pt-2 mx-auto"> or </div>
                <div class="col-sm-1 pt-2 mx-auto"> Absolute </div>
                <input disabled="disabled" readonly="readonly" type="number" class="col-lg-2 mr-1" />
                <div class="col-sm-1 pt-2"> {{ selectedCountry.currency }} </div>
              </b-row>
            </b-card-text>
            <b-card-text>
              <b-row>
                <div class="col-sm-2 pt-2">OPT Discount Percentage: </div>
                <input disabled="disabled" readonly="readonly" type="number" min="0" max="100" class="col-lg-2 mr-1" />
                <div class="col-sm-1 pt-2"> % </div>
                <!-- Colonne bottoni-->
                <b-col class="col-lg-12">
                  <span class="float-right">
                    <b-button variant="primary mr-1" @click="rollbackSolData()"><i
                        class="mdi mdi-rotate-left"></i>Rollback</b-button>
                    <b-button v-if="!showEditButton(activeSolCampaign)" variant="primary mr-1" disabled>
                      Save
                    </b-button>
                    <b-button v-else variant="primary  mr-1" @click="toggleElementStatus(solModel, solModel.visible)">
                      Save
                    </b-button>
                  </span>
                </b-col>
              </b-row>
            </b-card-text>
          </template>
        </template>
      </template>
    </b-card>
    <!--ONLINE TAXES-->
    <b-card :header="getTaxesLabel" header-bg-variant="primary" header-text-variant="light" id="online_taxes">
      <template>
        <!--creare tabella di 3 righe e 4 colonne-->
        <template v-if="selectedCountry && selectedCountry.solEnable">
          <b-card-text>
            <b-row>
              <b-col class="col-lg-2">Code</b-col>
              <b-col class="col-lg-3">B2C</b-col>
              <b-col class="col-lg-3">B2B</b-col>
              <b-col class="col-lg-3">B2E</b-col>
              <b-col class="col-lg-1">Delete</b-col>
            </b-row>
          </b-card-text>
          <b-card-text>
            <b-row v-if="isSolServiceActive && showVirtualproduct">
              <b-col class="col-lg-2">DOWNPAYMENT</b-col>
              <b-col class="col-lg-3">
                <b-select class="col-lg-2 mr-1" v-model="virtualProduct.downpayment" :value="default_downpayment">
                  <template v-for="downpayment in downpayments">
                    <option v-if="downpayment.active" :value="downpayment.downpayment">{{ downpayment.downpayment }}
                    </option>
                  </template>
                </b-select>
              </b-col>
              <b-col class="col-lg-1"></b-col>
            </b-row>

          </b-card-text>
          <b-card-text v-for="(taxe, i) in taxes">
            <b-row>
              <b-col class="col-lg-2">
                <div v-if="taxe[0].recordType == 'COUNTRY'">{{ taxe[0].taxDescription }}</div>
                <input v-else type="text" v-model="taxe[0].taxDescription" />
              </b-col>
              <b-col class="col-lg-3"><input type="text" min="0" max="100000" @keypress="isNumber($event)"
                  v-on:input="checkInsertNum(taxe[0])" class="col-lg-9" v-model="taxe[0].taxValue" /></b-col>
              <b-col class="col-lg-3"><input type="text" min="0" max="100000" @keypress="isNumber($event)"
                  v-on:input="checkInsertNum(taxe[1])" class="col-lg-9" v-model="taxe[1].taxValue" /></b-col>
              <b-col class="col-lg-3">
                <input type="text" min="0" max="100000" @keypress="isNumber($event)"
                  v-on:input="checkInsertNum(taxe[2])" class="col-lg-9" v-model="taxe[2].taxValue" />
              </b-col>
              <b-col class="col-lg-1">
                <b-button v-if="taxe[0].recordType != 'COUNTRY'" class="p-1 m-auto" size="sm"
                  style="max-width: 2.875rem;" variant="danger" @click="deleteTaxe(taxe, i)">
                  <i class="mdi mdi-delete"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card-text>
          <b-card-text>
            <b-row v-if="isSolServiceActive && showVirtualproduct">
              <b-col class="col-lg-2">DOWNPAYMENT</b-col>
              <b-col class="col-lg-3">
                <b-select class="col-lg-9 mr-1" v-model="virtualProduct.downpayment" :value="default_downpayment">
                  <b-form-select-option :value="null">---</b-form-select-option>
                  <template v-for="downpayment in downpayments">
                    <option v-if="downpayment.active" :value="downpayment.downpayment">{{ downpayment.downpayment }}
                    </option>
                  </template>
                </b-select>
              </b-col>
              <b-col class="col-lg-1"></b-col>
            </b-row>
          </b-card-text>
          <b-card-text>
            <b-row>
              <div class="col-sm-2 pt-2"> </div>

              <!-- Colonne bottoni-->
              <b-col class="col-lg-12">
                <span class="float-right">
                  <b-button variant="primary mr-1" @click="rollbackTaxes()"><i
                      class="mdi mdi-rotate-left"></i>Rollback</b-button>
                  <b-button variant="primary mr-1" @click="addTaxes()"><i class="mdi mdi-plus"></i>Add</b-button>
                  <b-button @click="saveSolTaxesData()" variant="primary mr-1">
                    Save
                  </b-button>
                </span>
              </b-col>
            </b-row>
          </b-card-text>
        </template>
      </template>
    </b-card>
    <!--Model Prices and Equipments-->
    <b-card header="Model Prices and Equipments" header-bg-variant="primary" header-text-variant="light"
      id="prices_equipment" :key="equipmentsTableKey" class="mt-4">
      <b-card-text v-if="(selectedCountry && selectedModel) && optionalList.length">
        <fragment v-if="selectedCountry.enableBaseOpt">
          <b-alert variant="warning" v-if="!basePriceInfo.pricelistActive && !selectedCountry.enableBaseOpt" dismissible
            :show="showDismissibleAlertPrice" @dismissed="showDismissibleAlertPrice = false">
            <i class="mdi mdi-alert"></i> {{ labels['priceconf.warning.unpublished.pricelist'] }}
          </b-alert>
          <b-row>
            <b-col class="col-lg-2 mr-1">Price Format:</b-col>
            <b-col class="col-lg-1 mr-1">Currency Code:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.impPr">Importer Price:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.mrpb">MRPBT & BT:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.chSprpbtbt">S RPBT&BT:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.usaDealer">Dealer Price:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.usaListPr">List Price:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.usaTotRet">Total Retail:</b-col>
            <b-col class="col-lg-1 mr-1" v-if="basePriceInfo.daNj">Da NJ:</b-col>
            <b-col class="col-lg-2 mr-1">Official base price of market:</b-col>
            <b-col class="col-lg-2 mr-1" v-if="isPriceFromAS400 && basePriceInfo.msrpBasePrice != null">Msrp base
              price:</b-col>
            <b-col class="col-lg-2">Final base price (displayed to user):</b-col>
            <b-col v-if="solModel != null" class="col-lg-1 mr-1">Price without tax:</b-col>
          </b-row>
          <b-row class="mt-1">
            <b-select class="col-lg-2 mr-1" v-model="activePricemask" :value="default_pricemask">
              <template v-for="mask in pricemaskList">
                <option v-if="!mask.disabled" :value="mask.value">{{ mask.label }}</option>
              </template>
            </b-select>
            <input type="text" class="col-lg-1 mr-1" v-model="activeCurrency" />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.impPr" v-if="basePriceInfo.impPr"
              disabled />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.mrpb" v-if="basePriceInfo.mrpb" disabled />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.chSprpbtbt" v-if="basePriceInfo.chSprpbtbt"
              disabled />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.usaDealer" v-if="basePriceInfo.usaDealer"
              disabled />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.usaListPr" v-if="basePriceInfo.usaListPr"
              disabled />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.usaTotRet" v-if="basePriceInfo.usaTotRet"
              disabled />
            <input type="text" class="col-lg-1 mr-1" v-model="basePriceInfo.daNj" v-if="basePriceInfo.daNj" disabled />
            <input type="text" class="col-lg-2 mr-1" v-model="basePriceInfo.price" />
            <input type="text" class="col-lg-2 mr-1" v-model="basePriceInfo.msrpBasePrice"
              v-if="isPriceFromAS400 && basePriceInfo.msrpBasePrice != null" disabled />
            <span class="col-lg-2 pt-2">{{ (basePriceInfo) ? basePriceInfo.finalPriceWithCurrencyRO : '' }}</span>
            <input v-if="solModel != null" type="text" class="col-lg-1 mr-1" :value="modelPriceWithoutTax" disabled />
          </b-row>
          <b-row class="mt-3 mb-3">
            <b-col class="col-lg-12">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="rollbackInfo()" v-if="showPricingButtons"><i
                    class="mdi mdi-rotate-left"></i>Rollback</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.impPr)"
                  v-if="showPricingButtons && basePriceInfo.impPr"><i class="mdi mdi-chevron-left"></i>Importer
                  Price</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.mrpb)"
                  v-if="showPricingButtons && basePriceInfo.mrpb"><i class="mdi mdi-chevron-left"></i>MRPBT &
                  BT</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.chSprpbtbt)"
                  v-if="basePriceInfo.chSprpbtbt"><i class="mdi mdi-chevron-left"></i>S RPBT&BT</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.usaDealer)"
                  v-if="basePriceInfo.usaDealer"><i class="mdi mdi-chevron-left"></i>Dealer Price</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.usaListPr)"
                  v-if="basePriceInfo.usaListPr"><i class="mdi mdi-chevron-left"></i>List Price</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.usaTotRet)"
                  v-if="basePriceInfo.usaTotRet"><i class="mdi mdi-chevron-left"></i>Total Retail</b-button>
                <b-button variant="primary mr-1" @click="setPriceTo('price', basePriceInfo.daNj)"
                  v-if="basePriceInfo.daNj"><i class="mdi mdi-chevron-left"></i>Da NJ</b-button>
                <b-button variant="primary mr-1" @click="priceMeTo(basePriceInfo, basePriceInfo.msrpBasePrice)"
                  v-if="isPriceFromAS400 && basePriceInfo.msrpBasePrice != null && showPricingButtons"><i
                    class="mdi mdi-arrow-left"></i>Copy
                  Msrp Price</b-button>
                <b-button variant="primary" v-if="!showAlert(optionalList) && basePriceInfo.price > 0"
                  @click="saveMarketOpt();"><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                <b-button variant="primary" v-else disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
                <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
                <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
              </span>
            </b-col>
          </b-row>
        </fragment>
        <fragment v-else>
          Official base price of market {{ (basePriceInfo) ? basePriceInfo.finalPriceWithCurrencyRO : '' }}
        </fragment>
        <b-alert v-if="selectedCountry.enableBaseOpt && (showAlert(optionalList) || (basePriceInfo.price <= 0))"
          variant="danger" dismissible :show="showDismissibleAlertPrice" @dismissed="showDismissibleAlertPrice = false">
          <i class="mdi mdi-alert-octagon"></i> {{ labels['priceconf.warning.void.opt.prices.existing'] }}
        </b-alert>
        <template>

        </template>
        <b-table id="equipmentsTable" striped border hover responsive sticky-header="500px" small :items="optionalList"
          :fields="specificVisibleFields('visibleToModelAndEq')" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          primary-key="_id" no-local-sorting no-provider-paging sort-icon-left class="mt-3" ref="equipmentsTable">

          <template v-slot:cell(HiddenBYPR)="data" lang="html">
            <b-row style="margin: 5px;">
              <h4 v-if="data.item.isHiddenByPcm" class="panel-title" style="margin:auto;">
                <a class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                  v-b-tooltip.hover title="Hidden By Product Catalog"
                  @click="curItem = data.item; toggleOptStatus(data.item, false)">
                  <i class="mdi mdi-eye-off-outline" style="display: block;"></i>
                </a>
              </h4>
            </b-row>
          </template>

          <template v-slot:cell(HideButton)="data" lang="html">
            <b-row style="margin: 5px;" v-if="data.item.isHideEnabled"
              @click="curItem = data.item; toggleOptStatus(data.item, false)">
              <input v-model="data.item.isHiddenByMarket" type="checkbox" v-b-tooltip.hover title="Hide Opt" />
            </b-row>
          </template>
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html">
            <b-tr v-if="selectedCountry.enableBaseOpt">
              <b-th
                :colspan="specificVisibleFields('visibleToModelAndEq').length - optVisibleButtons"></b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
              <b-th v-if="showPricingButtons" @click="mainListRollback('optionalList', 'defaultElementst.optionalList');"><b-button
                  variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
              <b-th @click="importAllPrices('optionalList', 'impPrice');" v-if="!isPriceFromAS400 && showPricingButtons"
                class="impPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
              <b-th @click="importAllPrices('optionalList', 'mrpbtPrice');" v-if="!isPriceFromAS400 && showPricingButtons"
                class="mrpbPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
              <b-th @click="importAllPrices('optionalList', 'msrp');" v-if="isPriceFromAS400 && showPricingButtons"
                class="msrpPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
            </b-tr>
          </template>

          <template v-slot:cell(officialPrice)="data" lang="html">
            <input v-if="!data.item.isStandard" type="text" v-model="data.item.price" :class="getBorderStyle(data.item)"
              :disabled="automaticPriceLocal && data.item.price != null" />
            <div v-else> (is Standard) </div>
          </template>
          <!-- A custom formatted column -->
          <template v-slot:cell(rollback)="data" lang="html">
            <b-button variant="secondary"
              @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.optionalList')"><i
                class="mdi mdi-rotate-left"></i></b-button>
          </template>

          <template v-slot:cell(InfoComponent)="data" lang="html">
            <b-button v-if="data.item.itemLastModInfo != 'No edit info' && selectedCountry.enableBaseOpt"
              class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
              @click="openModalInfo(data.item.itemLastModInfo)">
              <i class="mdi mdi-information-outline" style="display: block;"></i>
            </b-button>
          </template>


          <template v-slot:cell(ImpButton)="data" lang="html">
            <b-button v-if="data.item.impPrice" class="btn impPriceCol" variant="secondary" v-b-tooltip.hover
              :title="data.item.impPrice" @click="priceMeTo(data.item, data.item.impPrice)">
              &lt; {{ data.item.impPrice }}
            </b-button>
          </template>

          <template v-slot:cell(MrpbtButton)="data" lang="html">
            <b-button v-if="data.item.mrpbtPrice" class="btn mrpbPriceCol" variant="secondary" v-b-tooltip.hover
              :title="data.item.mrpbtPrice" @click="priceMeTo(data.item, data.item.mrpbtPrice)">
              &lt; {{ data.item.mrpbtPrice }}
            </b-button>
          </template>

          <template v-slot:cell(MsrpButton)="data" lang="html">
            <b-button v-if="data.item.msrp" class="btn msrpPrice" variant="secondary" v-b-tooltip.hover
              :title="data.item.msrp" @click="priceMeTo(data.item, data.item.msrp)">
              &lt; {{ data.item.msrp }}
            </b-button>
          </template>
          <i class="mdi mdi-alert-octagon"></i>
        </b-table>
      </b-card-text>
    </b-card>

    <!--FUORISERIE Model Prices and Equipments-->
    <b-card header="Fuoriserie Prices" header-bg-variant="primary" header-text-variant="light" id="prices_fuoriserie"
      class="mt-4">
      <b-card-text v-if="(selectedCountry && selectedModel) && fuoriserieList.length">
        <fragment v-if="selectedCountry.enableBaseOpt">
          <b-alert variant="warning" v-if="!basePriceInfo.pricelistActive && !selectedCountry.enableBaseOpt" dismissible
            :show="showDismissibleAlertPrice" @dismissed="showDismissibleAlertPrice = false">
            <i class="mdi mdi-alert"></i> {{ labels['priceconf.warning.unpublished.pricelist'] }}
          </b-alert>
          <b-row class="mt-3 mb-3">
            <b-col class="col-lg-12">
              <span class="float-right">
                <b-button variant="primary" v-if="!showAlert(fuoriserieList) && basePriceInfo.price > 0"
                  @click="saveEquipmentList(fuoriserieList, getCurUser.idUser)"><i class="mdi mdi-content-save"></i>Save
                  Changes</b-button>
                <b-button variant="primary" v-else disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
                <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
                <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
              </span>
            </b-col>
          </b-row>
        </fragment>
        <fragment v-else>
          Official base price of market {{ (basePriceInfo) ? basePriceInfo.finalPriceWithCurrencyRO : '' }}
        </fragment>
        <b-alert v-if="selectedCountry.enableBaseOpt && (showAlert(fuoriserieList) || (basePriceInfo.price <= 0))"
          variant="danger" dismissible :show="showDismissibleAlertPrice" @dismissed="showDismissibleAlertPrice = false">
          <i class="mdi mdi-alert-octagon"></i> {{ labels['priceconf.warning.void.opt.prices.existing'] }}
        </b-alert>
        <template>
        </template>
        <b-table id="fuoriseriesTable" striped border hover responsive sticky-header="500px" small
          :items="fuoriserieList" :fields="specificVisibleFields('visibleToModelAndEq')" :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" primary-key="_id" no-local-sorting no-provider-paging sort-icon-left class="mt-3"
          ref="fuoriseriesTable">

          <template v-slot:cell(HiddenBYPR)="data" lang="html">
            <b-row style="margin: 5px;">
              <h4 v-if="data.item.isHiddenByPcm" class="panel-title" style="margin:auto;">
                <a class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                  v-b-tooltip.hover title="Hidden By Product Catalog"
                  @click="curItem = data.item; toggleOptStatus(data.item, false)">
                  <i class="mdi mdi-eye-off-outline" style="display: block;"></i>
                </a>
              </h4>
            </b-row>
          </template>

          <template v-slot:cell(HideButton)="data" lang="html">
            <b-row style="margin: 5px;" v-if="data.item.isHideEnabled"
              @click="curItem = data.item; toggleOptStatus(data.item, false)">
              <input v-model="data.item.isHiddenByMarket" type="checkbox" v-b-tooltip.hover title="Hide Opt" />
            </b-row>
          </template>
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html">
            <b-tr v-if="selectedCountry.enableBaseOpt">
              <b-th
                :colspan="specificVisibleFields('visibleToModelAndEq').length - optVisibleButtons"></b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
              <b-th  v-if="showPricingButtons" @click="mainListRollback('fuoriserieList', 'defaultElementst.fuoriserieList');"><b-button
                  variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
              <b-th @click="importAllPrices('fuoriserieList', 'impPrice');" v-if="!isPriceFromAS400 && showPricingButtons"
                class="impPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
              <b-th @click="importAllPrices('fuoriserieList', 'mrpbtPrice');" v-if="!isPriceFromAS400 && showPricingButtons"
                class="mrpbPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
              <b-th @click="importAllPrices('fuoriserieList', 'msrp');" v-if="isPriceFromAS400 && showPricingButtons"
                class="msrpPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
            </b-tr>
          </template>

          <template v-slot:cell(officialPrice)="data" lang="html">
            <input v-if="!data.item.isStandard" type="text" v-model="data.item.price" :class="getBorderStyle(data.item)"
              :disabled="automaticPriceLocal && data.item.price != null" />
            <div v-else> (is Standard) </div>
          </template>
          <!-- A custom formatted column -->
          <template v-slot:cell(rollback)="data" lang="html">
            <b-button variant="secondary"
              @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.fuoriserieList')"><i
                class="mdi mdi-rotate-left"></i></b-button>
          </template>

          <template v-slot:cell(InfoComponent)="data" lang="html">
            <b-button v-if="data.item.itemLastModInfo != 'No edit info' && selectedCountry.enableBaseOpt"
              class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
              @click="openModalInfo(data.item.itemLastModInfo)">
              <i class="mdi mdi-information-outline" style="display: block;"></i>
            </b-button>
          </template>


          <template v-slot:cell(ImpButton)="data" lang="html">
            <b-button v-if="data.item.impPrice" class="btn impPriceCol" variant="secondary" v-b-tooltip.hover
              :title="data.item.impPrice" @click="priceMeTo(data.item, data.item.impPrice)">
              &lt; {{ data.item.impPrice }}
            </b-button>
          </template>

          <template v-slot:cell(MrpbtButton)="data" lang="html">
            <b-button v-if="data.item.mrpbtPrice" class="btn mrpbPriceCol" variant="secondary" v-b-tooltip.hover
              :title="data.item.mrpbtPrice" @click="priceMeTo(data.item, data.item.mrpbtPrice)">
              &lt; {{ data.item.mrpbtPrice }}
            </b-button>
          </template>

          <template v-slot:cell(MsrpButton)="data" lang="html">
            <b-button v-if="data.item.msrp" class="btn msrpPrice" variant="secondary" v-b-tooltip.hover
              :title="data.item.msrp" @click="priceMeTo(data.item, data.item.msrp)">
              &lt; {{ data.item.msrp }}
            </b-button>
          </template>
          <i class="mdi mdi-alert-octagon"></i>
        </b-table>
      </b-card-text>
    </b-card>

    <!--customer programs-->
    <b-card header="Customer Programs" header-bg-variant="primary" header-text-variant="light" id="customer_programs"
      class="mt-4">
      <b-card-text
        v-if="(selectedCountry && selectedModel) && selectedCountry.enableCustomerPrg && customerPrgList.length">
        <b-alert variant="danger" dismissible v-if="showAlert(customerPrgList)" :show="showDismissibleAlertPrice"
          @dismissed="showDismissibleAlertPrice = false">
          <i class="mdi mdi-alert-octagon"></i> {{ labels['priceconf.warning.void.opt.prices.existing'] }}
        </b-alert>
        <b-row v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
          <b-col class="col-lg-12">
            <span class="float-right">
              <b-button variant="primary" v-if="!showAlert(customerPrgList)"
                @click="saveEquipmentList(customerPrgList, getCurUser.idUser)"><i class="mdi mdi-content-save"></i>Save
                Changes</b-button>
              <b-button variant="primary" v-else disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
              <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
              <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
              <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
            </span>
          </b-col>
        </b-row>
        <b-table id="custProgTable" striped border hover responsive sticky-header="500px" small :items="customerPrgList"
          :fields="specificVisibleFields('visibleToCustomPrg')" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          primary-key="_id" no-local-sorting no-provider-paging sort-icon-left class="mt-3">
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html"
            v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
            <b-tr>
              <b-th :colspan="specificVisibleFields('visibleToCustomPrg').length - 1">
                <div style="min-height: 3vh;"></div>
              </b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
              <b-th @click="mainListRollback('customerPrgList', 'defaultElementst.customerPrgList');"><b-button
                  variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
              <b-th></b-th>
            </b-tr>
          </template>

          <template v-slot:cell(officialPrice)="data" lang="html">
            <input v-if="!data.item.isStandard" type="text" v-model="data.item.price"
              :class="getBorderStyle(data.item)" />
            <div v-else> (is Standard) </div>
          </template>

          <!-- A custom formatted column -->
          <template v-slot:cell(rollback)="data" lang="html">
            <b-button variant="secondary"
              @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.customerPrgList')"><i
                class="mdi mdi-rotate-left"></i></b-button>
          </template>
          <!-- TODO colonne custom per: hiddenProdCat, hidden, marketPrice, impPrice, mrpbtPrice -->
        </b-table>
      </b-card-text>
    </b-card>
    <!--accessories-->
    <b-card header="Accessories" header-bg-variant="primary" header-text-variant="light" id="accessories" class="mt-4">
      <b-card-text v-if="(selectedCountry && selectedModel) && accessoriesList.length">
        <b-alert variant="danger" dismissible
          v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt && showAlert(accessoriesList)"
          :show="showDismissibleAlertPrice" @dismissed="showDismissibleAlertPrice = false">
          <i class="mdi mdi-alert-octagon"></i> {{ labels['priceconf.warning.void.opt.prices.existing'] }}
        </b-alert>
        <b-row v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
          <b-col class="col-lg-12">
            <span class="float-right">
              <b-button variant="primary" v-if="!showAlert(accessoriesList)"
                @click="saveEquipmentList(accessoriesList, getCurUser.idUser)"><i class="mdi mdi-content-save"></i>Save
                Changes</b-button>
              <b-button variant="primary" v-else disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
              <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
              <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
              <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
            </span>
          </b-col>
        </b-row>
        <b-table id="accTable" striped border hover responsive sticky-header="500px" small :items="accessoriesList"
          :fields="specificVisibleFields('visibleToAcc')" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          primary-key="_id" no-local-sorting no-provider-paging sort-icon-left class="mt-3">
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html"
            v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
            <b-tr>
              <b-th :colspan="specificVisibleFields('visibleToAcc').length - accVisibleButtons">
                <div style="min-height: 3vh;"></div>
              </b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
              <b-th @click="mainListRollback('accessoriesList', 'defaultElementst.accessoriesList');"><b-button
                  variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
              <b-th @click="importAllPrices('accessoriesList', 'msrp');" v-if="isPriceFromAS400"
                class="msrpPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
              <b-th></b-th>
            </b-tr>
          </template>

          <template v-slot:cell(officialPrice)="data" lang="html">
            <input v-if="!data.item.isStandard" type="text" v-model="data.item.price"
              :class="getBorderStyle(data.item)" />
            <div v-else> (is Standard) </div>
          </template>

          <!-- A custom formatted column -->
          <template v-slot:cell(rollback)="data" lang="html">
            <b-button variant="secondary"
              @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.accessoriesList')"><i
                class="mdi mdi-rotate-left"></i></b-button>
          </template>
          <!-- TODO colonne custom per: hiddenProdCat, hidden, marketPrice, impPrice, mrpbtPrice -->
          <template v-slot:cell(MsrpButton)="data" lang="html">
            <b-button v-if="data.item.msrp" class="btn msrpPrice" variant="secondary" v-b-tooltip.hover
              :title="data.item.msrp" @click="priceMeTo(data.item, data.item.msrp)">
              &lt; {{ data.item.msrp }}
            </b-button>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
    <!--accessories-->
    <b-card header="Taxes" header-bg-variant="primary" header-text-variant="light" id="taxes" class="mt-4">
      <b-card-text v-if="(selectedCountry && selectedModel)">

        <b-row v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
          <b-col class="col-lg-12">
            <span class="float-right">
              <b-button variant="primary mr-1" @click="addNewTax()"><i class="mdi mdi-plus"
                  style="margin-right: 10px;"></i>Add a New Tax</b-button>
              <b-button variant="primary" @click="saveMarketDataTaxes();"><i class="mdi mdi-content-save"></i>Save
                Changes</b-button>
              <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
              <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
              <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
            </span>
          </b-col>
        </b-row>
        <b-row v-else>Taxes set by the market. For your information, these taxes are excluded from the dealer's
          pricelist:</b-row>
        <b-table v-if="taxList.length > 0" id="taxesTable" striped border hover responsive sticky-header="500px" small
          :items="taxList" :fields="specificVisibleFields('visibleToTax')" :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" primary-key="_id" no-local-sorting no-provider-paging sort-icon-left class="mt-3">
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html"
            v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
            <b-tr>
              <b-th :colspan="specificVisibleFields('visibleToTax').length - 2">
                <div style="min-height: 3vh;"></div>
              </b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
              <b-th @click="mainListRollback('taxList', 'defaultElementst.taxList');"><b-button variant="secondary"><i
                    class="mdi mdi-rotate-left"></i></b-button></b-th>
              <b-th></b-th>
            </b-tr>
          </template>

          <template v-slot:cell(editableDescription)="data" lang="html">
            <input v-if="selectedCountry && selectedCountry.enableBaseOpt" type="text" v-model="data.item.code"
              @input="data.item.description = data.item.code" />
            <fragment v-else>{{ data.item.code }}</fragment>
          </template>

          <template v-slot:cell(editableOfficialPrice)="data" lang="html">
            <input type="text" v-model="data.item.price" />
          </template>

          <!-- A custom formatted column -->
          <template v-slot:cell(rollback)="data" lang="html">
            <b-button variant="secondary"
              @click="curItem = data.item; rollbackTax(data.item, 'defaultElementst.taxList')"><i
                class="mdi mdi-rotate-left"></i></b-button>
          </template>
          <template v-slot:cell(RemoveTax)="data" lang="html">
            <b-button variant="secondary" @click="curItem = data.item; removeTax(data.item)"><i
                class="mdi mdi-close text-danger"></i></b-button>
          </template>

        </b-table>
      </b-card-text>
    </b-card>
  </section>
</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
const FileDownload = require('js-file-download');
const MomentWithTimezone = require('moment-timezone');
import PriceConfiguratorException from "../../../components/modals/price_configurator_exception.vue"
import mixin from '../../../mixin/mixin.js'
import moment from 'moment';
export default {
  name: 'price_configurator',
  mixins: [mixin],
  components: { PriceConfiguratorException },
  methods: {
    findQuotaEseente(taxType) {
      return this.findElementByTaxType(this.solTaxes.QUOTA_ESENTE, taxType);
    },
    backToCampaign() {
      if (this.comeFromSolCampaign) {
        this.setComeFromSolCampaign(false);
      } else if (this.startFromSolCampaign) {
        this.setStartFromSolCampaign(false);

      }
      console.log(this.getOriginalCampaignObject)
      var originalObject = JSON.stringify(this.getOriginalCampaignObject);
      console.log(JSON.parse(originalObject));
      this.$router.push({ name: "sol_campaign", params: JSON.parse(originalObject) });

    },
    backToSol() {
      this.setStartFromSolModel(false);
      this.$router.push({ name: "sol_model", params: this.getOriginalSolModelObject });
    },
    back() {
      if (this.comeFromSolCampaign || this.startFromSolCampaign) {
        this.backToCampaign();
      } else if (this.isFromSol || this.startFromSolModel) {
        this.backToSol();
      }
    },
    goToCampaign() {
      var vetele = this.selectedModel.value;
      if (this.activeSolCampaign != null) {
        this.setComeFromSolCampaign(false);
        this.setOriginalCampaignObject({ vetele: vetele, idCountry: this.activeSolCampaign.idCountry, idCampaign: this.activeSolCampaign.id, filterObj: this.activeSolCampaign, countryToSelect: this.selectedCountry, modelToSelect: this.selectedModel, from: 'price_conf' })
        this.$router.push({ name: "sol_campaign", params: this.getOriginalCampaignObject });
      }

      if (this.$route.params && !this.$route.params.primitiveObject) {
        // ora aggiungo l'oggetto dedicato alla sezione routeObjectMaps        
        this.$route.params.primitiveObject = this.primitiveObject;
      } else {
        // controllo l'esisteza dell'oggetto primitivo
      }



    },
    openModalInfo(message) {
      this.$bvModal.msgBoxOk(this.htmlToVNode(message.replaceAll("\\n", "<br/>")), {
        title: 'Info',
        size: 'sm',
        headerBgVariant: 'primary',
        headerTextVariant: 'light',
        okVariant: 'primary',
        hideHeaderClose: false,
        centered: true
      })
    },
    htmlToVNode(html) {
      return [
        this.$createElement('div', { domProps: { innerHTML: html } })
      ]
    },
    existsInListByCode(list, item) {
      let result = false
      return list.some(function (field) {
        return item.code === field.code
      });
    },
    editUploadedItem(item) {
      if (!this.existsInListByCode(this.editUploadList, item)) {
        this.editUploadList.push(item)
      } else {
        this.editUploadList.splice(this.editUploadList.indexOf(item), 1);
        this.editUploadList.push(item)
      }
    },
    showAlert(data) {
      var boolean = false;
      var price;
      data.forEach(element => {
        if (element.price == null || isNaN(element.price)) {
          boolean = true;
        }
        else {
          if (isNaN(element.price) == false) {
            price = element.price.toString().trim();
            if (price == "") {
              boolean = true;
            }
          }
        }
      });
      return boolean;
    },
    addNewTax() {
      var newTax = {
        vet: this.selectedModel.value,
        description: null,
        price: null,
        currency: this.selectedCountry.currency
      }
      this.taxList.push(newTax);
    },
    changeFileName() {
      if (document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else {
        this.fileName = '';
      }

    },
    initializeUpload() {
      this.uploadImportPricelistResultView = null
      this.$bvModal.show('modal-import')
      this.fileName = ''
      this.imported = false
    },
    removeTax(item) {
      var newList = this.removeFromArr(this.taxList, item);
      this.taxList = newList
    },
    saveEquipmentList(equipmentList, userModis, showUpdatedModal = true) {
      if(showUpdatedModal){
        this.addTask()
      }
      var params = '';
      if (userModis) {
        params = '?idUserModis=' + userModis;
      } else {
        params = '?idUserModis=' + this.getCurUser.username;
      }

      return this.axios
        .put('/ccb/auth/fe/priceConf/saveEquipmentList/' + this.selectedCountry.id + '/' + this.selectedModel.value + params, equipmentList, this.authHeader)
        .then(response => {
          if (response.status == 200) {
            if (showUpdatedModal) {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
            }
          }
        }
        ).then((result) => {
          this.removeTask()
          this.getModelBasePriceInfo(true);
        }).catch((err) => {

        }).finally(e => {
          if(showUpdatedModal){
            this.removeTask();
          }
        });

    },
    saveMarketDataTaxes() {
      this.addTask()
      this.axios
        .put('/ccb/auth/fe/priceConf/saveMarketDataTaxes/' + this.selectedCountry.id + '/' + this.selectedModel.value, this.taxList, this.authHeader)
        .then(response => {
          if (response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
              .then(value => {
                this.getTaxes();
              })
          }
        }).catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e => {
          this.removeTask()
        })

    },
    saveMarketOpt(showUpdatedModal = true) {
      if(showUpdatedModal){
        this.addTask()
      }

      var marketDataModel = {
        optList: this.optionalList,
        customerPrgList: this.customerPrgList,
        accList: this.accessoriesList,
        basePrice: this.basePriceInfo,
        userModis: this.getCurUser.idUser ? this.getCurUser.idUser : this.getCurUser.username,
        pricemask: this.activePricemask,
        currency: this.activeCurrency
      }

      return this.axios
        .put('/ccb/auth/fe/priceConf/saveMarketDataModelAndOpt/' + this.selectedCountry.id + '/' + this.selectedModel.value, marketDataModel, this.authHeader)
        .then(response => {
          this.removeTask()
            if (response.status == 200) {
              if(showUpdatedModal){
                this.$bvModal.msgBoxOk(response.data.message, {
                  okVariant: 'success',
                  hideHeaderClose: false,
                  centered: true
                })
                  .then(value => {
                    for (var x = 0; x < this.getCurUser.countries.length; x++) {
                      if (this.getCurUser.countries[x].id == this.selectedCountry.id) {

                        this.getCurUser.countries[x].pricemask = this.activePricemask;
                      }
                    }
                    this.getModelBasePriceInfo(true);
                  })
              }
              else{
                for (var x = 0; x < this.getCurUser.countries.length; x++) {
                  if (this.getCurUser.countries[x].id == this.selectedCountry.id) {

                    this.getCurUser.countries[x].pricemask = this.activePricemask;
                  }
                }
                this.getModelBasePriceInfo(true);
              }
            }
        }).catch(error => {
          this.$bvModal.msgBoxOk(error, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          // place the loginError state into our vuex store
        }).finally(e => {
          if(showUpdatedModal){
            this.removeTask()
          }
          // this.$bvModal.hide('modal-edit');
        })

    },
    getDetailsByModelVersion() {
      this.addTask()

      this.axios
        .get('/ccb/auth/fe/priceConf/detailsByModelVersion/' + this.selectedCountry.id + '/' + this.getCurLanguage + '/' + this.selectedModel.value, {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          // this.removeTask()
          this.detailsByModelVersion = response.data;
          this.splitData();
          this.getTaxes();
          //this.reloadBaseInfo();

        }).finally(e => {
          this.removeTask();
        });
    },
    getTaxes() {
      this.addTask()
      this.axios
        .get('/ccb/auth/fe/priceConf/getTaxes/' + this.selectedCountry.id + '/' + this.selectedModel.value, {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          this.removeTask()
          this.taxList = response.data;
          localStorage.setItem('defaultElementst.taxList', JSON.stringify(response.data));

        }).finally(e => {
          this.removeTask();
        });
    },
    splitData() {
      this.basePriceInfo.msrpBasePrice = this.findElementByCode(this.detailsByModelVersion.optionalsSection, this.selectedModel.value);
      if (this.basePriceInfo.msrpBasePrice && this.basePriceInfo.msrpBasePrice.msrp) {
        this.basePriceInfo.msrpBasePrice = this.basePriceInfo.msrpBasePrice.msrp;

        this.defaultElementst.basePriceInfo.msrpBasePrice = this.basePriceInfo.msrpBasePrice;
        localStorage.setItem('defaultElementst.basePriceInfo', JSON.stringify(this.defaultElementst.basePriceInfo));

        var msrpVehPrice = this.findElementByCode(this.detailsByModelVersion.optionalsSection, this.selectedModel.value)
        //remove from oprList
        var optListFiltered = this.detailsByModelVersion.optionalsSection.filter((a) => { return a.code != msrpVehPrice.code })
        this.detailsByModelVersion.optionalsSection = optListFiltered
        //remove from accList
        var accListFiltered = this.detailsByModelVersion.accessoriesSection.filter((a) => { return a.code != msrpVehPrice.code })
        this.detailsByModelVersion.accessoriesSection = accListFiltered
        //remove from custPrg
        var cusPrgListFiltered = this.detailsByModelVersion.customerPrgSection.filter((a) => { return a.code != msrpVehPrice.code })
        this.detailsByModelVersion.customerPrgSection = cusPrgListFiltered

      }

      this.accessoriesList = (this.detailsByModelVersion.accessoriesSection) ? this.filterAccessori(this.detailsByModelVersion.accessoriesSection) : [];
      this.customerPrgList = (this.detailsByModelVersion.customerPrgSection) ? this.filterCustPrg(this.detailsByModelVersion.customerPrgSection) : [];
      this.optionalList = (this.detailsByModelVersion.optionalsSection) ? this.filterOpt(this.detailsByModelVersion.optionalsSection) : [];
      this.fuoriserieList = (this.detailsByModelVersion.fuoriseriesSection) ? this.filterFuoriserie(this.detailsByModelVersion.fuoriseriesSection) : [];

      localStorage.setItem('defaultElementst.accessoriesList', JSON.stringify(this.accessoriesList));
      localStorage.setItem('defaultElementst.customerPrgList', JSON.stringify(this.customerPrgList));
      localStorage.setItem('defaultElementst.optionalList', JSON.stringify(this.optionalList));
      localStorage.setItem('defaultElementst.fuoriserieList', JSON.stringify(this.fuoriserieList));
      this.checkEmpties('optionalList', 'optExistUnpriced');
      this.checkEmpties('accessoriesList', 'accExistUnpriced');
      this.checkEmpties('customerPrgList', 'prgExistUnpriced');
      this.checkEmpties('fuoriserieList', 'fuoriserieExistUnpriced');
    },
    checkEmpties(listTarget, varTarget) {
      var isEmpty = false;
      this[listTarget].forEach((el) => {
        if (el.price || el.price >= 0) {
          isEmpty = true;

        }
      })
      this[varTarget] = isEmpty;
    },
    getModelBasePriceInfo(spinner) {
      if ((spinner != null && spinner) || (spinner == null)) {
        this.addTask()
      }
      this.axios
        .get('/ccb/auth/fe/priceConf/basePriceInfo/' + this.selectedCountry.id + '/' + this.selectedModel.value, {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          if (spinner) {
            this.removeTask()
          }
          this.defaultElementst.basePriceInfo = response.data;
          this.basePriceInfo = response.data;

          // inizializzo priceSettings
          this.priceSettings = (this.basePriceInfo && this.basePriceInfo.priceSettings)
            ? { ...this.basePriceInfo.priceSettings }
            : {
              id: null,
              countryId: this.selectedCountry ? this.selectedCountry.id : null,
              vetele: this.selectedModel ? this.selectedModel.value : null,
              automaticPrice: false,
              showCC: this.basePriceInfo.pricelistActive,
              showMXE: this.basePriceInfo.pricelistActive,
              showSNI: this.basePriceInfo.pricelistActive
            };

          this.automaticPriceLocal = this.priceSettings.automaticPrice

          if (this.priceSettings.automaticPrice === true) {
            this.hideColumnsExceptNorthAmerica();
          }
          else {
            if (!this.isPriceFromAS400) {
              this.restoreHiddenColumns();
            } else {
              this.fields.find(e => e.key == 'MrpbtButton').visible = false;
              this.fields.find(e => e.key == 'ImpButton').visible = false;
              this.fields.find(e => e.key == 'MsrpButton').visible = true;
              this.fields.find(e => e.key == 'rollback').visible = true;
              this.showPricingButtons = true;
              this.equipmentsTableKey++;
              this.fuoriserieTableKey++;
            }
          }

          // VAT visualizzata: automaticVat (se presente) altrimenti vat del market
          this.automaticVatLocal = (this.selectedCountry && this.selectedCountry.automaticVat != null)
            ? this.selectedCountry.automaticVat
            : (this.selectedCountry ? this.selectedCountry.vat : 0);


          localStorage.setItem('defaultElementst.basePriceInfo', JSON.stringify(response.data));
          this.getDetailsByModelVersion();

        })
    },
    restoreHiddenColumns() {
      const defaultVisibleKeys = ['rollback', 'ImpButton', 'MrpbtButton', 'MsrpButton'];
      this.fields.forEach(field => {
        if (defaultVisibleKeys.includes(field.key)) {
          if (field.key === 'MsrpButton') {
            // Solo USA/CAN
            field.visible = this.isPriceFromAS400;
          } else {
            field.visible = 'enableBaseOpt';
          }
        }
      });

      this.showPricingButtons = true;
      this.equipmentsTableKey++;
      this.fuoriserieTableKey++;
    },
    rollbackSolData() {
      this.findSolModel();
    },
    reloadBaseInfo() {
      // var defValue = JSON.parse(window.sessionStorage.getItem('defaultElementst.basePriceInfo'));
      // this.basePriceInfo = defValue;
      this.activePricemask = this.default_pricemask;
      this.getModelBasePriceInfo(true);
    },
    rollbackInfo() {

      var defValue = JSON.parse(localStorage.getItem('defaultElementst.basePriceInfo'));
      this.basePriceInfo = defValue;
    },
    mainListRollback(mainList, listName) {
      var target =
        this[mainList].forEach((el) => {
          this.curItem = el;
          this.rollbackMe(el, listName)//
        })



    },
    rollbackMe(item, ssName) {
      var defValue = JSON.parse(localStorage.getItem(ssName));
      var match = this.findElementByCode(defValue, item.code);
      if (match && match.code)
        this.curItem.price = match.price;
    },
    rollbackTax(item, ssName) {
      var defValue = JSON.parse(localStorage.getItem(ssName));
      var match = this.findElementByDescription(defValue, item.description);
      if (match && match.description)
        this.curItem.description = match.description;
    },
    setPriceTo(propName, price) {
      if (price)
        this.basePriceInfo[propName] = price;
    },
    priceMeTo(target, price) {
      if (price != null)
        target.price = price;
    },
    importAllPrices(mainList, target) {
      this[mainList].forEach((el) => {
        if (el[target]) {
          el.price = el[target]
        }
      })
    },
    getPricemaskList(spinner) {
      if (!this.pricemaskList) {
        if (spinner) {
          this.addTask()
        }
        this.axios
          .get('/ccb/auth/fe/priceConf/pricemaskList', {
            params: null,
            ...this.authHeader
          }
          )
          .then((response) => {
            if (spinner) {
              this.removeTask()
            }
            this.pricemaskList = response.data
          }).finally(e => {
            this.removeTask();
          });
      }

    },
    getPdfLink() {
      this.axios
        .get('/ccb/auth/fe/consoleConfig/getValue/PRICE_CONF_PDF_URL', {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          this.pdfLink = response.data
        });

    },
    selectItem(name) {
      setTimeout(() => {
        document.querySelector("#" + name).click();
      }, 300);

    },
    getBorderStyle(item) {
      var classColor = '';
      var hasPrice = (item.price != null && item.price >= 0)
      if (!hasPrice && this.basePriceInfo.pricelistActive) {
        classColor = 'red';
      } else {
        classColor = ''
      }
      return classColor;
    },
    openPdf() {
      window.open(this.pdfLink, 'TutorialMarketPdf', 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    },
    specificVisibleFields(fieldName) {
      //agire sul campo visible dell'array fields per nascondere/mostrare i campi in base alle varie possibilità
      var filteredFields = this.fields.filter(field =>
        (field.visible == 'enableBaseOpt' ?
          this.selectedCountry != null &&
          this.selectedCountry.enableBaseOpt : field.visible) &&
        field[fieldName])

      return filteredFields;
    },
    exportPriceList() {
      this.addTask()
      let equipmentList = {
        "OPTIONALS": this.optionalList,
        "FUORISERIE": this.fuoriserieList,
        "CUSTOMER PROGRAMS": this.customerPrgList,
        "ACCESSORIES": this.accessoriesList
      }
      let bodyParams = {
        basePrice: this.basePriceInfo,
        equipmentList: equipmentList
      }
      let params = {
        marketId: this.selectedCountry.id,
        modelCode: this.selectedModel.value,
        modelName: this.selectedModel.label.split(" ")[0],
      }
      this.axios
        .post('/ccb/auth/fe/priceConf/exportPricelist', bodyParams, {
          responseType: 'blob',
          params: params,
          ...this.authHeader
        }
        )
        .then((response) => {
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /fileName[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }).finally(e => {
          this.removeTask();
        });
    },
    importPriceList() {
      this.addTask()
      let file = document.querySelector('#file-input').files[0]
      let equipmentList = {
        "OPTIONALS": this.optionalList,
        "FUORISERIE": this.fuoriserieList,
        "CUSTOMER PROGRAMS": this.customerPrgList,
        "ACCESSORIES": this.accessoriesList
      }
      let bodyParams = {
        equipmentList: equipmentList,
        priceConfEditedItemList: this.editUploadList
      }
      let formData = new FormData()
      formData.append("uploadFile", file)
      formData.append("pCountry", this.selectedCountry.id)
      formData.append("pVetele", this.selectedModel.value)
      formData.append("pIdModisUser", (this.getCurUser.idUser ? this.getCurUser.idUser : this.getCurUser.username))
      formData.append("importPriceConfUtilJson", JSON.stringify(bodyParams))
      this.axios.post("/ccb/auth/fe/priceConf/importPricelist", formData, {
        //params: params,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        ...this.authHeader
      }
      )
        .then((result) => {
          this.imported = true
          this.removeTask()
          this.uploadImportPricelistResultView = result.data
          this.editUploadList = []
          this.getModelBasePriceInfo(false)
        }).catch((err) => {
          this.removeTask()
        });
    },
    uploadFile() {
      this.addTask()
      let file = document.querySelector('#file-input').files[0]
      let equipmentList = {
        "OPTIONALS": this.optionalList,
        "FUORISERIE": this.fuoriserieList,
        "CUSTOMER PROGRAMS": this.customerPrgList,
        "ACCESSORIES": this.accessoriesList
      }
      let bodyParams = {
        equipmentList: equipmentList
      }
      let formData = new FormData()
      formData.append("uploadFile", file)
      formData.append("pCountry", this.selectedCountry.id)
      formData.append("pVetele", this.selectedModel.value)
      formData.append("importPriceConfUtilJson", JSON.stringify(bodyParams))
      this.axios.post("/ccb/auth/fe/priceConf/uploadPricelistFromExcel", formData, {
        //params: params,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        ...this.authHeader
      }
      )
        .then((result) => {
          this.removeTask()
          this.uploadImportPricelistResultView = result.data
        }).catch((err) => {
          this.removeTask()
        });

    },
    searchSolactiveCampaignByCountryAndModel() {
      var year = '';
      var month = '';
      var day = '';
      var filterDate = '';

      var date = new Date();
      var day = moment(date, "DD/MM/YYYY").date();
      var year = moment(date, "DD/MM/YYYY").year();
      var month = moment(date, "DD/MM/YYYY").month();
      filterDate = new Date(year, month, day, 23, 59, 59, 999);
      this.addTask()
      this.axios
        .get('/ccb/auth/fe/priceConf/solCountryModelTaxes2/' + this.selectedCountry.id + '/' + this.selectedModel.value, {
          params: {
            startDate: filterDate
          },
          ...this.authHeader
        }
        )
        .then((response) => {
          this.removeSolTaxes();
          this.solData = response.data.solCampaignData.length > 0 ? response.data.solCampaignData : null;

          console.log("1 TEST");
          console.log(response.data.solTaxesData);
          console.log("2 TEST");

          this.solTaxesData = response.data.solTaxesData;
          this.solTaxesDataBackup = JSON.stringify(response.data.solTaxesData);
          this.activeSolCampaignBackup = response.data.solCampaignData;
          this.activeSolCampaign = this.solData != null ? this.solData[0] : null;
          this.default_virtualProduct = null;
          this.downpayments = (response.data.downpayments != null && response.data.downpayments.length > 0) ? response.data.downpayments : null;
          if (this.downpayments != null && this.downpayments.length > 0) {
            this.downpayments.sort((a, b) => a.downpayment - b.downpayment)
          }
          this.virtualProduct = response.data.virtualProduct;

          if (!this.virtualProduct && this.downpayments && this.downpayments.length > 0) { //non ho il virtualproduct ma ho i downpayment
            this.default_virtualProduct = { id: null, country: this.selectedCountry.id, model: this.selectedModel.value, downpayment: null };
            this.virtualProduct = this.default_virtualProduct;
          }
          this.default_downpayment = null;
          if (this.downpayments && this.downpayments.length > 0) {
            //this.default_downpayment = this.downpayments[0].downpayment // associo al valor di default il primo downpayment
          }

          if (response.data.virtualProduct != null) {
            var found = this.downpayments.find(function (a) {
              return a.downpayment == response.data.virtualProduct.downpayment
            })
            if (found)
              this.default_downpayment = found.downpayment
          }

          this.virtualProduct.downpayment = this.default_downpayment

          window.scoper
          this.fillTaxes();
        }).finally(e => {
          this.removeTask()
        });
    },
    fillTaxes() {
      this.solTaxesData.forEach(tax => {
        if (this.solTaxes[tax.taxDescription.replaceAll(" ", "_")])
          this.solTaxes[tax.taxDescription.replaceAll(" ", "_")].push(tax)
        else
          this.solTaxes[tax.taxDescription.replaceAll(" ", "_")] = [tax]
      })
      Object.keys(this.solTaxes).forEach(tax => {
        this.taxes.push(this.solTaxes[tax])
      })
      this.getPriceWithoutTax();
    },
    removeSolTaxes() {
      this.solData = null;
      this.activeSolCampaignBackup = null;
      this.activeSolCampaign = null;
      this.solTaxesDataBackup = null;
      this.solTaxesData = [];
      this.solTaxes = [];
      this.taxes = [];
    },
    rollbackTaxes() {
      // gestire le tasse
      this.taxes = []
      this.solTaxes = []
      this.solTaxesData = JSON.parse(this.solTaxesDataBackup);
      this.solTaxesData.forEach(tax => {
        if (this.solTaxes[tax.taxDescription.replaceAll(" ", "_")])
          this.solTaxes[tax.taxDescription.replaceAll(" ", "_")].push(tax)
        else
          this.solTaxes[tax.taxDescription.replaceAll(" ", "_")] = [tax]
      })
      Object.keys(this.solTaxes).forEach(tax => {
        this.taxes.push(this.solTaxes[tax])
      })
      this.getPriceWithoutTax();
    },
    saveSolTaxesData() {
      var error = false;
      let solNewTaxesList = [];

      /*
      solNewTaxesList.push(this.getMessaSuStradaB2B ? this.getMessaSuStradaB2B : this.newMessaSuStradaB2B)
      solNewTaxesList.push(this.getMessaSuStradaB2C ? this.getMessaSuStradaB2C : this.newMessaSuStradaB2C)
      solNewTaxesList.push(this.getMessaSuStradaB2E ? this.getMessaSuStradaB2E : this.newMessaSuStradaB2E)

      solNewTaxesList.push(this.getQuotaEsenteB2B ? this.getQuotaEsenteB2B : this.newQuotaEsenteB2B)
      solNewTaxesList.push(this.getQuotaEsenteB2C ? this.getQuotaEsenteB2C : this.newQuotaEsenteB2C)
      solNewTaxesList.push(this.getQuotaEsenteB2E ? this.getQuotaEsenteB2E : this.newQuotaEsenteB2E)
      */

      this.taxesBkUp = [];
      this.solTaxesBkUp = [];

      this.solTaxesDataBkUp = JSON.parse(this.solTaxesDataBackup);
      this.solTaxesDataBkUp.forEach(tax => {
        if (this.solTaxesBkUp[tax.taxDescription.replaceAll(" ", "_")])
          this.solTaxesBkUp[tax.taxDescription.replaceAll(" ", "_")].push(tax)
        else
          this.solTaxesBkUp[tax.taxDescription.replaceAll(" ", "_")] = [tax]
      })
      Object.keys(this.solTaxesBkUp).forEach(tax => {
        this.taxesBkUp.push(this.solTaxesBkUp[tax])
      })


      for (var tax of this.taxes) {
        if (tax[0].taxDescription) {
          tax.forEach(t => t.taxDescription = tax[0].taxDescription)


          var check0 = false;
          var check1 = false;
          var check2 = false;

          if (this.taxesBkUp.filter(t => (t[0].taxDescription == tax[0].taxDescription && t[0].taxType == tax[0].taxType && t[0].taxValue == tax[0].taxValue)).length == 0) {
            check0 = true;
          }
          if (this.taxesBkUp.filter(t => (t[1].taxDescription == tax[1].taxDescription && t[1].taxType == tax[1].taxType && t[1].taxValue == tax[1].taxValue)).length == 0) {
            check1 = true;
          }
          if (this.taxesBkUp.filter(t => (t[2].taxDescription == tax[2].taxDescription && t[2].taxType == tax[2].taxType && t[2].taxValue == tax[2].taxValue)).length == 0) {
            check2 = true;
          }
          if (check0 || check1 || check2) {
            solNewTaxesList = solNewTaxesList.concat(tax)
          }
        } else {
          this.$bvModal.msgBoxOk("Descrption required", {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          error = true;
          break;
        }
        if (this.taxes.filter(t => t[0].taxDescription == tax[0].taxDescription).length > 1) {
          this.$bvModal.msgBoxOk("Description already present", {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          error = true;
          break;
        }
      }


      console.log("solNewTaxesList");
      console.log(solNewTaxesList);

      if (solNewTaxesList.length > 0 && !error) {
        var taxesAndDownpayment = { taxList: solNewTaxesList, virtualProduct: this.virtualProduct }
        this.addTask();
        this.axios
          .post('/ccb/auth/fe/priceConf/saveSolTaxes', taxesAndDownpayment, this.authHeader)
          .then(response => {
            if (response.status == 200) {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
                .then(value => {
                  this.searchSolactiveCampaignByCountryAndModel();
                })
            }
          }).catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e => {
            this.removeTask();
          })
      }
    },

    saveSolTaxesDataTest() {
      var error = false;
      let solNewTaxesList = [];

      this.taxesBkUp = [];
      this.solTaxesBkUp = [];

      this.solTaxesDataBkUp = JSON.parse(this.solTaxesDataBackup);
      this.solTaxesDataBkUp.forEach(tax => {
        if (this.solTaxesBkUp[tax.taxDescription.replaceAll(" ", "_")])
          this.solTaxesBkUp[tax.taxDescription.replaceAll(" ", "_")].push(tax)
        else
          this.solTaxesBkUp[tax.taxDescription.replaceAll(" ", "_")] = [tax]
      })
      Object.keys(this.solTaxesBkUp).forEach(tax => {
        this.taxesBkUp.push(this.solTaxesBkUp[tax])
      })

      console.log("save test");
      for (var tax of this.taxes) {

        /*
        console.log(tax[0].taxType);
        console.log(tax[1].taxType);    
        console.log(tax[2].taxType);    
        */

        var check0 = false;
        var check1 = false;
        var check2 = false;

        if (this.taxesBkUp.filter(t => (t[0].taxDescription == tax[0].taxDescription && t[0].taxType == tax[0].taxType && t[0].taxValue == tax[0].taxValue)).length == 0) {
          check0 = true;
        }
        if (this.taxesBkUp.filter(t => (t[1].taxDescription == tax[1].taxDescription && t[1].taxType == tax[1].taxType && t[1].taxValue == tax[1].taxValue)).length == 0) {
          check1 = true;
        }
        if (this.taxesBkUp.filter(t => (t[2].taxDescription == tax[2].taxDescription && t[2].taxType == tax[2].taxType && t[2].taxValue == tax[2].taxValue)).length == 0) {
          check2 = true;
        }
        if (check0 || check1 || check2) {
          this.$bvModal.msgBoxOk(tax[0].taxDescription, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          error = true;
          break;
        }



        /* 
        for(var tax2 of tax) {
   
         console.log(tax);
 
         }
         */

      }


    },

    saveCurItem(curItem, editMode) {
      var intLabObj = curItem
      intLabObj.lastUpdate = new Date();
      this.addTask()
      var urlBase = '/ccb/auth/fe/solCampaign/' + intLabObj.id + "/" + editMode + "/" + (this.getCurUser.userAliasFromModis ? this.getCurUser.userAliasFromModis : this.getCurUser.username);
      this.axios
        .put(urlBase, intLabObj, this.authHeader)
        .then(response => {
          if (response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
              .then(value => {
                this.searchSolactiveCampaignByCountryAndModel();
              })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e => {
          this.removeTask()
        })
    },
    addTask() {
      this.setSpinnerStatus(true);
      this.tasklist.push(this.tasklist.length)
    },
    removeTask() {
      if (this.tasklist.length > 0) {
        this.tasklist.pop()
      }
      if (this.tasklist.length < 1)
        this.setSpinnerStatus(false)
    },
    active(curItem, visibilityValue) {
      this.addTask()
      var intLabObj = null;
      if (this.isHQUser) {
        intLabObj = { idSolModel: curItem.id.idSol }
      } else {
        intLabObj = { idSolModelMarket: curItem.id.idSolMarket }
      }

      intLabObj.visible = visibilityValue;
      intLabObj.updateDate = new Date();
      if (this.getCurUser.userAliasFromModis)
        intLabObj.updateUser = this.getCurUser.userAliasFromModis;
      else
        intLabObj.updateUser = this.getCurUser.username;

      var id = this.isHQUser ? intLabObj.idSolModel : intLabObj.idSolModelMarket;
      var urlBase = '/ccb/auth/fe/solModel/' + this.isHQUser;
      this.axios
        .put(urlBase, intLabObj, this.authHeader)
        .then(response => {
          if (response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
              .then(value => {
                this.findSolModel();
              })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e => {
          this.removeTask()
          this.$bvModal.hide('modal-edit');
        })
    },
    showEditButton(item) {
      return this.activeSolCampaign != null
        && this.activeSolCampaign.description
        && this.activeSolCampaign.dateStart
        && this.activeSolCampaign.dateEnd
        && this.activeSolCampaign.idCountry
        && this.activeSolCampaign.solCampaignModel
        && this.activeSolCampaign.solCampaignModel.length > 0
        && this.canModify;
    },
    toggleElementStatus(item, visibilityValue) {
      var stato = (!visibilityValue) ? 'deactivate' : 'activate'
      this.$bvModal.msgBoxConfirm('Do you want to ' + stato + ' Visibility to Vehicle ' + item.vetele + ' ?', {
        title: 'Change Status',
        okVariant: 'danger',
        okTitle: 'Continue',
        cancelTitle: 'Cancel',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            this.active(item, visibilityValue);
          }
        })
    },
    findSolModel() {
      this.setLastSearch(this.findSolModel)
      this.addTask();
      var params = {
        page: this.currentPage - 1, size: this.perPage, sortBy: this.solSortBy, sortDesc: this.sortDesc, isHQUser: (this.getCurUser.isHQUser) ? this.getCurUser.isHQUser : false
      }

      if (this.selectedCountry) {
        this.solFilterObj.adm = this.selectedCountry.tabele;
        // this.solFilterObj.idCountry = this.selectedCountry.id;
        this.solFilterObj.market = this.selectedCountry.codMercato;
      }
      else {
        this.solFilterObj.adm = null;
        this.solFilterObj.market = null;
      }

      if (this.selectedModel)
        this.solFilterObj.vetele = this.selectedModel.value;
      else {
        this.solFilterObj.vetele = null;
      }
      this.solFilterObj.showActive = false;
      this.solFilterObj.countryList = this.getCurUser.countries

      this.axios
        .post('/ccb/auth/fe/solModel/allPaged', this.solFilterObj, {
          params: params,
          ...this.authHeader
        }
        )
        .then(response => {
          var solModelList = response.data.content;
          if (solModelList.length > 0) {
            this.solModel = this.findElementByIdCountry(solModelList, this.selectedCountry.id);
            this.canModify = (!this.getCurUser.isHQUser && this.solModel != null);
            if (this.solModel == null) {
              this.solModel = this.findElementBySolMarket(solModelList, 0);
              this.canModify = (this.getCurUser.isHQUser && this.solModel != null);
            }
          };
          this.searchSolactiveCampaignByCountryAndModel();

        }).finally(e => {
          this.removeTask();
        });
    },
    checkIfExistVeteleActiveAndFindSol() {
      this.solModel = null;
      this.addTask()
      var vetele = this.selectedModel.value;
      this.axios
        .post("/ccb/auth/fe/commercialModel/checkIfExistVeteleActive/" + vetele, null, this.authHeader)
        .then(response => {
          if (response.status == 200) {
            this.findSolModel();
          }
        }).catch(error => {
          console.log("%c " + vetele + ": Model not active", "color:red");
        })
        .finally(e => {
          this.removeTask()
        })
    },
    closeModal() {
      this.$refs.PriceConfiguratoException.hide()
    },
    updateBackupData() {
      this.backupData = {
        optionalList: JSON.parse(JSON.stringify(this.optionalList)),
        basePriceInfo: JSON.parse(JSON.stringify(this.basePriceInfo)),
        customerPrgList: JSON.parse(JSON.stringify(this.customerPrgList)),
        accessoriesList: JSON.parse(JSON.stringify(this.accessoriesList))
      };
    },
    restoreBackup() {
      this.optionalList = this.backupData.optionalList;
      this.basePriceInfo = this.backupData.basePriceInfo;
      this.customerPrgList = this.backupData.customerPrgList;
      this.accessoriesList = this.backupData.accessoriesList;
    },
    initNewSolTaxes() {
      let pModel = this.selectedModel.value;
      let pCountry = this.selectedCountry.id;
      let pDescM = 'MESSA SU STRADA';
      let pDescQ = 'QUOTA ESENTE';
      this.newMessaSuStradaB2B = { ...this.newSolTax(pModel, pCountry, pDescM, 'B2B') };
      this.newMessaSuStradaB2C = { ...this.newSolTax(pModel, pCountry, pDescM, 'B2C') };
      this.newMessaSuStradaB2E = { ...this.newSolTax(pModel, pCountry, pDescM, 'B2E') };
      this.newQuotaEsenteB2B = { ...this.newSolTax(pModel, pCountry, pDescQ, 'B2B') };
      this.newQuotaEsenteB2C = { ...this.newSolTax(pModel, pCountry, pDescQ, 'B2C') };
      this.newQuotaEsenteB2E = { ...this.newSolTax(pModel, pCountry, pDescQ, 'B2E') };
    },
    isNumber(evt = KeyboardEvent) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
      const keyPressed = evt.key;

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    checkInsertNum(source) {
      let data = source.taxValue;
      if (data == null || !data) {
        data = 0.00;
      } else
        if (data && parseInt(data) <= 0) {
          data = 0.00;
        }
      source.taxValue = data;
    },
    getPriceWithoutTax() {
      let basePrice = this.basePriceInfo.finalPriceRODefaultFormat
      let vat = this.selectedCountry.vat

      let mssB2C = this.getMessaSuStradaB2C
      let qeB2C = this.getQuotaEsenteB2C

      let mssB2B = this.getMessaSuStradaB2B
      let qeB2B = this.getQuotaEsenteB2B
      if (mssB2C && qeB2C && mssB2B && qeB2B) {
        let priceDetax = basePrice - (mssB2C.taxValue + qeB2C.taxValue)
        priceDetax = (100 * priceDetax) / (100 + vat);
        priceDetax = priceDetax + (mssB2B.taxValue + qeB2B.taxValue)

        this.modelPriceWithoutTax = parseFloat(priceDetax).toFixed(2);
      }

    },
    canSaveTaxes() {
      var canSaveMss = false
      var canSaveQe = false

      if ((this.getMessaSuStradaB2C != null && this.getMessaSuStradaB2C.taxValue != 0.00) || (this.getMessaSuStradaB2B != null && this.getMessaSuStradaB2B.taxValue != 0.00) || (this.getMessaSuStradaB2E != null && this.getMessaSuStradaB2E.taxValue != 0.00)) {
        canSaveMss = true
      }
      if ((this.getQuotaEsenteB2C != null && this.getQuotaEsenteB2C.taxValue != 0.00) || (this.getQuotaEsenteB2B != null && this.getQuotaEsenteB2B.taxValue != 0.00) || (this.getQuotaEsenteB2E != null && this.getQuotaEsenteB2E.taxValue != 0.00)) {
        canSaveQe = true
      }
      //mss modifica nn, check new 
      if ((this.newMessaSuStradaB2C != null && this.newMessaSuStradaB2C.taxValue != 0.00) || (this.newMessaSuStradaB2B != null && this.newMessaSuStradaB2B.taxValue != 0.00) || (this.newMessaSuStradaB2E != null && this.newMessaSuStradaB2E.taxValue != 0.00)) {
        canSaveMss = true
      }
      if ((this.newQuotaEsenteB2C != null && this.newQuotaEsenteB2C.taxValue != 0.00) || (this.newQuotaEsenteB2B != null && this.newQuotaEsenteB2B.taxValue != 0.00) || (this.newQuotaEsenteB2E != null && this.newQuotaEsenteB2E.taxValue != 0.00)) {
        canSaveQe = true
      }

      return canSaveMss && canSaveQe;
    },
    checkSolServiceStatus() {
      this.axios
        .get('/ccb/auth/fe/consoleConfig/getValue/SOL_SERVICE_AVAILABLE', {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          this.setSolServiceActive(false)
          if (new String(response.data).toLowerCase() == 'true')
            this.setSolServiceActive(true)
        });

    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setOriginalCampaignObject',
      'setComeFromSolCampaign',
      'setStartFromSolCampaign',
      'setStartFromSolModel',
      'setSolServiceActive'
    ]),
    cloneObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    addTaxes() {
      let pModel = this.selectedModel.value;
      let pCountry = this.selectedCountry.id;
      this.taxes.push([{ ...this.newSolTax(pModel, pCountry, null, 'B2C') }, { ...this.newSolTax(pModel, pCountry, null, 'B2B') }, { ...this.newSolTax(pModel, pCountry, null, 'B2E') }]);
    },
    deleteTaxe(taxe, index) {
      if (taxe[0].id) {
        var ids = taxe.map(t => t.id)
        this.addTask()
        this.axios.post('/ccb/auth/fe/priceConf/deleteSolTaxes', ids, this.authHeader)
          .then(response => {
            if (response.status == 200) {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
                .then(value => {
                  this.searchSolactiveCampaignByCountryAndModel();
                })
            }
          }).catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e => {
            this.removeTask()
          })
      } else {
        this.taxes.splice(index, 1);
      }
    },
    // Salvataggio sezione Settings.
    // - Se Automatic = true ma mancano prezzi, mostra il modale, forza automatic = false e prosegue il salvataggio (VAT comunque salvabile).
    // - Chiama nuova API backend /savePriceSettings
    savePriceSettings() {
      // Validazione attivazione automatica
      let automaticPrice = this.priceSettings.automaticPrice;

      if (automaticPrice && !this.validateAutomaticPricing()) {
        // avviso e disattivo
        this.$bvModal.show('modal-auto-pricing-warning');
        automaticPrice = false;
        this.priceSettings.automaticPrice = false;
      }
      
      if (!this.basePriceInfo.pricelistActive) {
        this.priceSettings.showCC = false;
        this.priceSettings.showMXE = false;
        this.priceSettings.showSNI = false;
      }

      const payload = {
        ...this.priceSettings,
        countryId: this.selectedCountry ? this.selectedCountry.id : null,
        vetele: this.selectedModel ? this.selectedModel.value : null,
        automaticPrice,
        insertUser: this.getCurUser.idUser ? this.getCurUser.idUser : this.getCurUser.username,
        visible: this.basePriceInfo.pricelistActive
      };

      if (automaticPrice === true){
        payload.automaticVat = (this.automaticVatLocal != null ? this.automaticVatLocal : (this.selectedCountry ? this.selectedCountry.vat : null))
      }

      this.addTask()
      this.axios.post('/ccb/auth/fe/priceConf/savePricelistSettings', payload, this.authHeader)
        .then(resp => {
          if (resp && resp.status === 200) {
            if (payload.automaticVat != null) {
              this.$store.commit('updateCountry', {
                ...this.selectedCountry,
                automaticVat: payload.automaticVat
              });

              if (this.selectedCountry) {
                this.$set(this.selectedCountry, 'automaticVat', this.automaticVatLocal);
              }
            }

            //Todo: per testare che vada mettere ! davanti al controllo anche per un mercato/modello non abilitato
            if (this.priceSettings.automaticPrice) {
              //Ribaltare i prezzi
              this.syncOfficialPricesOnAutomatic()
              //solo quando i prezzi sono ribaltati scatenare il salvataggio
              Promise.all([
                this.saveMarketOpt(false),
                this.saveEquipmentList(this.fuoriserieList, this.getCurUser.idUser, false),
              ])
            }
            return Promise.resolve()
          }
        })
        .then(() => {
          this.$bvModal.msgBoxOk('Updated', {
            okVariant: 'success',
            centered: true
          })
        })
        .catch(() => {
          this.$bvModal.msgBoxOk('Error while saving data', {
            okVariant: 'danger',
            centered: true
          })
        })
        .finally(() => {
          //le colonne e i bottoni vengono nascosti qui dentro
          this.getModelBasePriceInfo(true)
          this.removeTask()
        })
    },
    syncOfficialPricesOnAutomatic() {
      // In modalità automatica:
      // - officialPrice(price) viene sovrascritto con msrpbtPrice oppure msrp
      // - input diventa readonly / disabled
      // - se non presente il valore target, imposta 0
      const srcField = this.useMsrpInsteadOfMrpbt ? 'msrp' : 'mrpbtPrice';

      const apply = (arr) => {
        (arr || []).forEach(el => {
          if (el && !el.isStandard) {
            const v = Number(el[srcField]);
            const vat = Number(this.automaticVatLocal) || 0;
            el.price = !isNaN(v) ? (v + ((v * vat) / 100)) : 0;
          }
        });
      };

      apply(this.optionalList);
      apply(this.fuoriserieList);
    },
    validateAutomaticPricing() {
      // Controllo la presenza di almeno un prezzo valido per attivare Automatic.
      // - mrpbtPrice per mercati standard
      // - msrp per USA/Canada (AS400)

      const field = this.useMsrpInsteadOfMrpbt ? 'msrp' : 'mrpbtPrice';
      let hasInOptionals = false;
      let hasInFuoriserie = false;
      if (this.optionalList.length !== 0)
        hasInOptionals = (this.optionalList || []).some(o => !o.isStandard && (o[field] || o[field] === 0) && o[field] != null);
      if (this.fuoriserieList.length !== 0)
        hasInFuoriserie = (this.fuoriserieList || []).some(o => !o.isStandard && (o[field] || o[field] === 0) && o[field] != null);

      return (hasInOptionals || hasInFuoriserie);
    },
    hideColumnsExceptNorthAmerica() {
      const isNorthAmerica =
        this.selectedCountry?.codMercato === 'USA' ||
        this.selectedCountry?.codMercato === 'CAN';

      if (isNorthAmerica) {
        // Nel caso di USA e Canda invece le colonne e i pulsanti da nascondere saranno rollback, copy msrp price
        const hideKeys = ['rollback', 'MsrpButton'];

        this.hideKeysFunction(hideKeys)

        // Disattivo i bottoni rollback e copy msrp price
        this.showPricingButtons = false;
        // this.isPriceFromAS400 = true;

        this.equipmentsTableKey++;
        this.fuoriserieTableKey++;

        return;
      }

      const hideKeys = ['rollback', 'ImpButton', 'MrpbtButton'];

      this.hideKeysFunction(hideKeys)


      this.showPricingButtons = false

      this.equipmentsTableKey++;
      this.fuoriserieTableKey++;
    },
    hideKeysFunction(hideKeys) {
      hideKeys.forEach(key => {
        const field = this.fields.find(f => f.key === key);
        if (field) field.visible = false;
      });
    },
    getTooltipDescrSettings() {
      this.axios
        .get('/ccb/auth/fe/consoleConfig/searchByCodeLike', {
          params: { pattern: 'TOOLTIP_%' },
          ...this.authHeader
        })
        .then((resp) => {
          if (resp && resp.data) {
            this.tooltips = {};
            resp.data.forEach(cfg => {
              this.tooltips[cfg.code] = cfg.value;
            });
          }
        })
        .catch(err => {
          console.error("Error loading tooltip:", err);
        });
    },
    getTooltip(key) {
      return this.tooltips[key] || '';
    },
  },
  data() {
    return {
      selectedVisibility: null,
      options: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
      primitiveObject: {
        vetele: null,
        idCountry: null,
        idCampaign: null,
        routeObjectMaps: [
        ]
      },
      routeActionElement: {
        isMainOrigin: false,
        active: false,
        backFunction: function () { },
        actionFunction: function () { },
        filterObj: {}

      },
      modelPriceWithoutTax: '',
      isFromSol: false,
      equipmentsTableKey: 0,
      fuoriserieTableKey: 0,
      pdfLink: '',
      optAlert: false,
      fileName: '',
      detailsByModelVersion: null,
      optionalList: (this.detailsByModelVersion && this.detailsByModelVersion.optionalsSection) ? this.detailsByModelVersion.optionalsSection : [],
      accessoriesList: (this.detailsByModelVersion && this.detailsByModelVersion.accessoriesSection) ? this.detailsByModelVersion.accessoriesSection : [],
      customerPrgList: (this.detailsByModelVersion && this.detailsByModelVersion.customerPrgSection) ? this.detailsByModelVersion.customerPrgSection : [],
      fuoriserieList: (this.detailsByModelVersion && this.detailsByModelVersion.fuoriseriesSection) ? this.detailsByModelVersion.fuoriseriesSection : [],
      defaultElementst: {
        basePriceInfo: null,
        accessoriesList: [],
        optionalList: [],
        customerPrgList: [],
        fuoriserieList: []
      },
      basePriceInfo: null,
      activeImporterPrice: null,
      default_marketPrice: (this.basePriceInfo && this.basePriceInfo.price) ? this.basePriceInfo.price : null,
      activeMarketPrice: null,
      activeMrpbt: null,
      default_pricemask: (this.selectedCountry && this.selectedCountry.pricemask) ? this.selectedCountry.pricemask : null,
      activePricemask: null,
      default_currency: (this.selectedCountry && this.selectedCountry.currency) ? this.selectedCountry.currency : null,
      activeCurrency: null,
      currentStatus: null,
      pricemaskList: null,
      URLsaveMarketModelEq: '/priceConfig/marketModelEq/save',//saveMarketDataModelAndOpt
      marketModelEqObj: null,
      URLsaveCustomerPrg: '/priceConfig/customerPrgSection/saveEquipmentList',
      customerPrgObj: null,
      URLsaveAcc: '/priceConfig/accessoriesSection/saveEquipmentList',
      accObj: null,
      URLsaveTaxes: '/priceConfig/saveMarketDataTaxes',
      taxList: [],
      selectedCountry: (this.getCurUser) ? this.getCurUser.countries[0] : null,
      selectedModel: this.$store.state.selectedModel,
      detail_customerPrg: {},
      optExistUnpriced: false,
      prgExistUnpriced: false,
      accExistUnpriced: false,
      fuoriserieExistUnpriced: false,
      showDismissibleAlertPrice: true,
      currentPage: 1,
      perPage: 10,
      sortBy: 'code',
      solSortBy: '',
      sortDesc: false,
      curItem: null,
      filterSolModelObj: null,
      isFromCampaign: false,
      isBackFromCampaign: false,
      campaignId: null,
      default_downpayment: null,
      active_downpayment: null,
      items: [
      ],
      uploadPreviewFields: [
        {
          key: 'isChecked',
          label: '',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'code',
          label: 'Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'name',
          label: 'Name',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'officialPrice',
          label: 'Official price of market',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'status',
          label: 'Detail',
          thClass: 'newLine',
          visible: true,
          sortable: false
        }
      ],
      fields: [
        {
          key: 'dateInsReadonlyString',
          label: 'Insert date in grid',
          thClass: 'newLine',
          visible: true,
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'HiddenBYPR',
          label: 'Hidden by Prod. Cat.',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: false,
          sortable: false,
        },
        {
          key: 'HideButton',
          label: 'Hide',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'code',
          label: 'Code',
          thClass: 'newLine',
          visible: true,
          visibleToModelAndEq: true,
          visibleToCustomPrg: true,
          visibleToAcc: true,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'description',
          label: 'Name',
          thClass: 'newLine',
          visible: true,
          visibleToModelAndEq: true,
          visibleToCustomPrg: true,
          visibleToAcc: true,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'editableDescription',
          label: 'Name',
          thClass: 'newLine',
          visible: true,
          visibleToModelAndEq: false,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: true,
          sortable: false
        },
        {
          key: 'officialPrice',
          label: 'Official price of market',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: true,
          visibleToAcc: true,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'editableOfficialPrice',
          label: 'Official price of market',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: false,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: true,
          sortable: false
        },
        {
          key: 'InfoComponent',
          label: 'Price info log',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'finalPriceWithCurrencyRO',
          label: 'Final price (displayed to user)',
          thClass: 'newLine',
          visible: true,
          visibleToModelAndEq: true,
          visibleToCustomPrg: true,
          visibleToAcc: true,
          visibleToTax: true,
          sortable: false
        },
        {
          key: 'rollback',
          label: 'Rollback',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: true,
          visibleToAcc: true,
          visibleToTax: true,
          sortable: false
        },
        {
          key: 'RemoveTax',
          label: 'Remove Tax',
          thClass: 'newLine',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: false,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: true,
          sortable: false
        },
        {
          key: 'ImpButton',
          label: 'Imp. Price',
          thClass: 'newLine',
          class: 'impPriceCol',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'MrpbtButton',
          label: 'Mrpbt Price',
          thClass: 'newLine',
          class: 'mrpbPriceCol',
          visible: 'enableBaseOpt',
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: false,
          visibleToTax: false,
          sortable: false
        },
        {
          key: 'MsrpButton',
          label: 'Msrp Price',
          thClass: 'newLine',
          class: 'msrpPriceCol',
          visible: false,
          visibleToModelAndEq: true,
          visibleToCustomPrg: false,
          visibleToAcc: true,
          visibleToTax: false,
          sortable: false
        }
      ],
      labels: {
        "priceconf.warning.unpublished.pricelist": "AAA - The market has not published this pricelist Therefore, currently it's not visible into the web Car Configurator yet.",
        "priceconf.warning.void.opt.prices.existing": "Some price is missing in the list below. Please be aware that equipment with blank price won't be displayed on the car configurator. To avoid this behavior please fill the price field (even with value = 0).",
        "priceconf.warning.alternative.pricelistDisc": "In New Inventory Shopping Tool, this pricelist will be applied to all VINs that contain the specified OPT code (or VINs that do not contain it, in case of \"escluded\" checked)." +
          "In Car Configurator, this pricelist won't have any effect.",
        "priceconf.onlineTaxesLabel": "",
        "priceconf.fincoTaxesLabel": "FINCO Taxes"
      },
      files: [],
      fileLabel: "Choose File",
      uploadImportPricelistResultView: null,
      editUploadList: [],
      imported: false,
      optVisibleButtons: 3,
      accVisibleButtons: 1,
      activeSolCampaign: null,
      isHQUser: false,
      isMKTUser: false,
      solFilterObj: {
        id: {
          idSolMarket: null,
          idSol: null
        },
        vetele: null,
        adm: null,
        market: null,
        showHq: null,
        showActive: null,
        idCountry: null,
        countryList: []
      },
      solModel: null,
      maxPerc: 100,
      minPerc: 0,
      canModify: false,
      backupData: null,
      solTaxesDataBackup: null,
      solTaxesData: [],
      solTaxes: {
        MESSA_SU_STRADA: [],
        QUOTA_ESENTE: []
      },
      newMessaSuStradaB2B: null,
      newMessaSuStradaB2C: null,
      newMessaSuStradaB2E: null,
      newQuotaEsenteB2B: null,
      newQuotaEsenteB2C: null,
      newQuotaEsenteB2E: null,
      downpayments: [],
      virtualProduct: null,
      default_virtualProduct: { id: null, country: null, model: null, downpayment: null },
      newSolTax: (pModel, pCountry, pDesc, pType) => {
        return {
          "id": null,
          "model": pModel,
          "countryId": pCountry,
          "taxValue": 0.00,
          "taxDescription": pDesc,
          "taxType": pType
        }
      },
      taxes: [],
      tasklist: [],
      added: 0,
      removed: 0,
      priceSettings: {
        id: null,
        countryId: null,
        vetele: null,
        automaticPrice: false
      },
      automaticVatLocal: null,
      autoImport: false,
      showPricingButtons: true,
      automaticPriceLocal: false,
      tooltips: {},
    }
  },
  computed: {
    getMessaSuStradaB2C() {
      return this.findElementByTaxType(this.solTaxes.MESSA_SU_STRADA, "B2C");
    },
    getMessaSuStradaB2B() {
      return this.findElementByTaxType(this.solTaxes.MESSA_SU_STRADA, "B2B");
    },
    getMessaSuStradaB2E() {
      return this.findElementByTaxType(this.solTaxes.MESSA_SU_STRADA, "B2E");
    },
    getQuotaEsenteB2C() {
      return this.findElementByTaxType(this.solTaxes.QUOTA_ESENTE, "B2C");
    },
    getQuotaEsenteB2B() {
      return this.findElementByTaxType(this.solTaxes.QUOTA_ESENTE, "B2B");
    },
    getQuotaEsenteB2E() {
      return this.findElementByTaxType(this.solTaxes.QUOTA_ESENTE, "B2E");
    },
    getMsrpPriceColVisible() {
      return this.msrpPriceColVisible;
    },
    getImpPriceColVisible() {
      return this.impPriceColVisible;
    },
    getMrpbPriceColVisible() {
      return this.mrpbPriceColVisible;
    },
    isBusy() {
      return false;
    },
    getIsEnablePriceEdit() {
      return ((this.selectedCountry.enableAccessories && this.accessoriesList && this.accessoriesList.length) ||
        (this.selectedCountry.enableBaseOpt && this.customerPrgList && this.customerPrgList.length) ||
        (this.selectedCountry.enableBaseOpt && this.optionalList && this.optionalList.length)
      ) ? true : false;
    },
    visibleFields() {
      //agire sul campo visible dell'array fields per nascondere/mostrare i campi in base alle varie possibilità
      return this.fields.filter(field => field.visible)
    },
    isPriceFromAS400() {
      var result = (this.selectedCountry) ? this.selectedCountry.priceFromAS400 : false;
      return result;
    },
    comeFromSolCampaign() {
      return this.getComeFromSolCampaign;
    },
    startFromSolCampaign() {
      return this.getStartFromSolCampaign;
    },
    startFromSolModel() {
      return this.getStartFromSolModel
    },
    useMsrpInsteadOfMrpbt() {
      // Per regole USA/Canada uso il flag già presente
      return this.isPriceFromAS400;
    },
    showVirtualproduct() {
      return (this.downpayments && this.downpayments.length > 0)
    },
    isSolServiceActive() {
      return this.getSolServiceActive
    },
    getTaxesLabel() {
      return (this.isSolServiceActive) ? this.labels['priceconf.onlineTaxesLabel'] : this.labels['priceconf.fincoTaxesLabel']
    },
    ...mapGetters([
      'getCurLanguage',
      'getCurUser',
      'authHeader',
      'getComeFromSolCampaign',
      'getStartFromSolCampaign',
      'getStartFromSolModel',
      'getOriginalCampaignObject',
      'getOriginalSolModelObject',
      'getSolServiceActive'
    ])
  },
  watch: {
    isPriceFromAS400(newVal, oldVal) {
      if (newVal == true) {
        this.fields.find(e => { return e.key == 'MrpbtButton' }).visible = false;
        this.fields.find(e => { return e.key == 'ImpButton' }).visible = false;
        this.fields.find(e => { return e.key == 'MsrpButton' }).visible = true;
        this.optVisibleButtons = 2;
        this.accVisibleButtons = 2;
      } else {
        this.basePriceInfo.msrpBasePrice = null;
        this.fields.find(e => { return e.key == 'MrpbtButton' }).visible = 'enableBaseOpt';
        this.fields.find(e => { return e.key == 'ImpButton' }).visible = 'enableBaseOpt';
        this.fields.find(e => { return e.key == 'MsrpButton' }).visible = false;
        this.optVisibleButtons = 3;
        this.accVisibleButtons = 1;
      }
      if (!this.selectedCountry.enableBaseOpt) {
        this.fields.find(e => { return e.key == 'MsrpButton' }).visible = false;
      }
    },
    selectedCountry(newVal, oldVal) {
      this.activePricemask = (newVal.pricemask)
      this.activeCurrency = (newVal.currency)
      this.default_pricemask = (newVal.pricemask) ? newVal.pricemask : this.default_pricemask;
      this.default_currency = (newVal.currency) ? newVal.currency : this.default_currency;
      if (!this.isFromSol && !this.isFromCampaign && !this.isBackFromCampaign) {
        if (newVal.modelGroupItemList && newVal.modelGroupItemList.length > 0 && newVal.modelGroupItemList[0].items.length > 0)
          this.selectedModel = newVal.modelGroupItemList[0].items[0];
        else
          this.selectedModel = null;
        this.equipmentsTableKey++;
      }
      if (this.selectedModel != null)
        this.initNewSolTaxes();
    },
    selectedModel(newVal, oldVal) {
      this.initNewSolTaxes();
      if (this.selectedCountry.solEnable) {
        this.checkIfExistVeteleActiveAndFindSol()
      } else {
        this.solData = null;
        this.solModel = null;
        this.activeSolCampaignBackup = null;
        this.activeSolCampaign = null;
      }
      this.removeSolTaxes();
      this.getModelBasePriceInfo(true);
    },
    'activeSolCampaign.discOpt': {
      handler: function (value) {
        if (value > this.maxPerc)
          this.activeSolCampaign.discOpt = this.maxPerc
        if (value < this.minPerc)
          this.activeSolCampaign.discOpt = this.minPerc
      }
    },
    'activeSolCampaign.discPerc': {
      handler: function (value) {
        if (value > this.maxPerc)
          this.activeSolCampaign.discPerc = this.maxPerc
        if (value < this.minPerc)
          this.activeSolCampaign.discPerc = this.minPerc
      }
    },
    priceSettings: {
      handler: function (val) {
        if(!val.showCC && !val.showMXE && !val.showSNI && this.basePriceInfo.pricelistActive) {
          this.basePriceInfo.pricelistActive = false;
        }
      },
      deep: true
    },
    'basePriceInfo.pricelistActive'(val) {
      if (!val) {
        this.priceSettings = {
          ...this.priceSettings,
          showCC: false,
          showMXE: false,
          showSNI: false
        }
      } else {
        this.priceSettings = {
          ...this.priceSettings,
          showCC: true,
          showMXE: true,
          showSNI: true
        }
      }
    },
  },
  mounted() {
    window.scoper = this;
    this.getPricemaskList(false);
    this.selectedCountry = (this.selectedCountry) ? this.selectedCountry : (
      (this.getCurUser && this.getCurUser.countries && this.getCurUser.countries.length)
        ? this.getCurUser.countries[0] : null);

    this.setCurApp('price_conf');
    this.setLastSearch(this.getModelBasePriceInfo)
    this.getPdfLink();
    this.getTooltipDescrSettings();
    this.checkSolServiceStatus();
    this.isHQUser = this.getCurUser.isHQUser != null ? this.getCurUser.isHQUser : false;
    this.isMKTUser = this.getCurUser.mktg != null ? this.getCurUser.mktg : false;
    if (this.$route.params && this.$route.params.primitiveObject) {
      // cose da fare nel caso si arrivi da un'altra pagina

    }

    if (this.$route.params && this.$route.params.vetele && this.$route.params.idCountry) {
      var vetele = this.$route.params.vetele;
      var countryId = this.$route.params.idCountry;
      var countryList = this.getCurUser.countries;
      this.selectedCountry = countryList.find(country => country.id == countryId);
      if (this.selectedCountry) {
        var listModels = this.selectedCountry.modelGroupItemList;
        var model = listModels.find(model => model.items.find(item => item.value == vetele));
        var modelSelected = model.items.find(item => item.value == vetele);

        console.log(this.getOriginalCampaignObject)

        if (this.$route.params.from == 'sol_campaign') {
          this.isFromCampaign = true;
          this.isFromSol = false;
          this.campaignId = this.$route.params.idCampaign;
        } else if (this.$route.params.from == 'sol_model') {
          this.isFromSol = true;
          this.isFromCampaign = false;
          this.filterSolModelObj = this.$route.params.filterObj;
        } else if (this.$route.params.from == 'back_from_sol_campaign') {
          this.isFromCampaign = false;
          this.isFromSol = false;
          this.isBackFromCampaign = true;
          this.campaignId = this.$route.params.idCampaign;
        } else if (this.$route.params.from == 'back_from_sol_model') {
          this.isFromSol = false;
          this.isFromCampaign = false;
          this.isBackFromCampaign = true;
          this.filterSolModelObj = this.$route.params.filterObj;
          // this.selectedModel = modelSelected.items.find(value => value.value == this.$route.params.vetele);
        }
        if (modelSelected) {
          this.selectedModel = modelSelected;
        }
      }
    }
    this.canModify = (!this.getCurUser.isHQUser);
    this.solFilterObj.countryList = this.getCurUser.countries;
    this.solFilterObj.idCountry = null;
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";

.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

.modal-price-configurator-exception .modal-dialog {
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.modal-price-configurator-exception .modal-content {
  overflow: hidden;
}

.modal-price-configurator-exception .modal-body {
  overflow-y: auto;
}
</style>
